import { orderText } from './payments/orderManagementText';
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import Loader from "../Layout/loader.gif";
import CardsForm from "../pageInside/creditCardType";
import Modal from 'react-bootstrap/Modal';
import ErrorAlert from "../pageInside/ErrorAlert";
import { CustomersRetrieve, retrievePayment, PaymentIntent, listePM_createStripeCusTomer } from "../auth/stripe";
import contries from "../../countries.json";
import ImagesLoadingOrderGraphic from "./imagesLoadingOrderGraphic";
import { createOrder, AddImgGraphicOrder, getTeamPaymentIntent } from "../auth/apiProduct";
import { checkoutAuthorization } from "../auth/checkoutAuthorization";
import { checkoutAttempt } from "../auth/checkoutAttempt";
import StripeError from "../pageInside/StripeError";
import { getElakayLang, getAddressById, isAuthenticated, getUserPUBToken } from "../auth";
import GraphicPreviewModal from "./Graffiticonfiguratorartifact/GraffitiPreview.js"
import GraffitiConfigurator from "./Graffiticonfiguratorartifact/GraffitiConfigurator.jsx"
import {

  ItemsOrder,
  prodDiscount,
  prodPrice,
  prodFrService,
  prodFrVente,
  prodFrRef,
  TaxOrder,
  getTotal,
  prodFrTransaction,
  totalFrais,
  inComeSeller,
  elakayFrais,
  calProfit
} from "../auth/allPriceFeet";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { REACT_PK, toImageUrl } from "../../config";
import { prepareDropshippingOrderProduct } from "./dropshippingVariant";

import './checkout.css';
import { elakayAutoText } from "./dataElakay";
import useShippingEstimate, { buildEstimateItems, buildEstimateDestination, pickEstimateAddress } from "./shippingEstimate/useShippingEstimate";
import { ShippingCostValue, ShippingEstimateDetails, SHIPPING_BLOCKING_SOURCES, RATE_BLOCKING_SOURCES, blockedLineMessage } from "./shippingEstimate/ShippingEstimateSummary";
import { itemsTotal, fetchDestinationTax, selectShippingEstimate } from "./checkoutTotals";
import { TaxQuoteValue, TaxBasisNote, isTaxErrorCode, taxErrorReason } from "./checkoutTaxDisplay";
import AddressLocationSelector from "./addressLocation/AddressLocationSelector";
import CheckoutPaymentMethods, { checkoutMethodActionLabel } from "./payments/CheckoutPaymentMethods";
import PayPalCheckoutButton, { isPayPalEligible } from "./payments/PayPalCheckoutButton";
import WalletPayButton, { useWalletAvailability } from "./payments/WalletPayButton";
import { displayableCheckoutMethods, resolveCheckoutEntryAction, resolveSelectedMethod } from "./payments/paymentMethodsLogic";
import { paymentErrorMessage } from "./payments/walletLabels";
import { quoteCheckoutAPI, getAvailablePaymentMethodsAPI, attachWalletMethodAPI, authorizePayPalOrderAPI, cancelPayPalOrderAPI, syncStripeOrderAPI } from "../auth/paymentsApi";
import { toLocationValue, fromLocationValue, STRIPE_FIELDS } from "./addressLocation/addressLocationData";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["checkoutProd"]?.[key] || fallback;

// A checkout image is valid once it resolves to a real URL through Elakay's own image helper --
// never by guessing from the raw stored value's format. Elakay-hosted images (Dropshipping In
// included) are legitimately stored as a relative /elakay_api/image-assets/<id> path by design
// (see elakay_services/imageAssetService.js's own comment on why a host is never baked in); an
// external CDN URL (native uploads, CJ dropshipping) already comes back absolute and passes
// through toImageUrl() unchanged. A true module-level export (pure, no closure) so this exact
// check is unit-testable on its own, separate from getPaymentButtonReason's stateful validation.
export const isValidProductImage = (urlImg) => {
  if (!urlImg || typeof urlImg !== "string" || !urlImg.trim()) return false;
  return Boolean(toImageUrl(urlImg));
};

// utils/graphicValidation.js


export function isGraphicInfoValid(graphicInfo) {
  if (!graphicInfo) return false;

  const sourceType = graphicInfo.sourceType;

  if (sourceType === "custom") {
    const slots = graphicInfo.slots || [];
    if (slots.length === 0) return false;
    return slots.some(slot => {
      const hasBg = slot.url && !slot.url.startsWith("blob:") && !slot.url.startsWith("data:");
      const hasText = (slot.slotState?.texts || []).some(t => t?.content?.trim().length > 0);
      const hasLayer = (slot.slotState?.layers || []).some(l => {
        const url = l?.urlImg || l?.src || l?.url || "";
        return url && !url.startsWith("blob:") && !url.startsWith("data:");
      });
      return hasBg || hasText || hasLayer;
    });
  }

  if (sourceType === "ask") {
    const ask = graphicInfo.askSellerData || {};
    const notEmpty = (s) => typeof s === "string" && s.trim().length > 0;
    return (
      notEmpty(ask.specialInstructions)  ||
      notEmpty(ask.artistMessage)        ||
      notEmpty(ask.avoidInstructions)    ||
      notEmpty(ask.requiredInstructions) ||
      notEmpty(ask.detailLevel)          ||
      notEmpty(ask.budget)               ||
      ask.desiredDate                    ||
      (ask.stylePrefs?.length > 0)       ||
      (ask.inspirations?.length > 0)     ||
      (ask.refs?.some(r => r))
    );
  }

  if (sourceType === "template") {
    const ref = graphicInfo.templateRef;
    return ref 
      && typeof ref === "string" 
      && /^[a-f0-9]{24}$/i.test(ref);
  }

  return false;
}
/* ══════════════════════════════════════════════════════
   🆕 localStorage helpers pour persister le graphic order
   
   Permet de :
   - Sauvegarder l'état du graphic avant le paiement
   - Restaurer si l'utilisateur ferme le modal puis revient
   - Auto-expiration après 24h (le draft serveur expire aussi)
══════════════════════════════════════════════════════ */

const GRAPHIC_STORAGE_KEY = "elakay_graphic_draft";
const GRAPHIC_STORAGE_TTL = 24 * 60 * 60 * 1000; // 24h en ms

/**
 * Sauvegarde l'état complet du graphic order dans localStorage.
 * @param {string} productID  - ID du produit (clé unique)
 * @param {object} data       - { graphicOrderId, sourceType, templateRef, draftOrderId, ... }
 */
const saveGraphicToLocalStorage = (productID, data) => {
  if (!productID || !data) return false;

  try {
    /* Récupère le store existant (multi-produits) */
    const raw = localStorage.getItem(GRAPHIC_STORAGE_KEY);
    const store = raw ? JSON.parse(raw) : {};

    /* Nettoie les entrées expirées avant d'ajouter */
    const now = Date.now();
    Object.keys(store).forEach(key => {
      if (store[key]?.expiresAt && store[key].expiresAt < now) {
        delete store[key];
      }
    });

    /* Ajoute / met à jour l'entrée du produit */
    store[productID] = {
      ...data,
      savedAt: now,
      expiresAt: now + GRAPHIC_STORAGE_TTL
    };

    localStorage.setItem(GRAPHIC_STORAGE_KEY, JSON.stringify(store));
    return true;
  } catch (err) {
    console.warn("saveGraphicToLocalStorage failed:", err);
    /* Soit quota dépassé, soit localStorage désactivé (mode privé Safari) */
    return false;
  }
};

/**
 * Récupère l'état graphic sauvegardé pour un produit.
 * Renvoie null si expiré, manquant, ou en cas d'erreur.
 */
const loadGraphicFromLocalStorage = (productID) => {
  if (!productID) return null;

  try {
    const raw = localStorage.getItem(GRAPHIC_STORAGE_KEY);
    if (!raw) return null;

    const store = JSON.parse(raw);
    const entry = store[productID];

    if (!entry) return null;

    /* Check expiration */
    if (entry.expiresAt && entry.expiresAt < Date.now()) {
      /* Cleanup auto */
      delete store[productID];
      localStorage.setItem(GRAPHIC_STORAGE_KEY, JSON.stringify(store));
      return null;
    }

    return entry;
  } catch (err) {
    console.warn("loadGraphicFromLocalStorage failed:", err);
    return null;
  }
};

/**
 * Supprime l'état graphic d'un produit (après paiement réussi par exemple).
 */
const clearGraphicFromLocalStorage = (productID) => {
  if (!productID) return false;

  try {
    const raw = localStorage.getItem(GRAPHIC_STORAGE_KEY);
    if (!raw) return true;

    const store = JSON.parse(raw);
    delete store[productID];

    /* Si plus rien, supprime la clé entière */
    if (Object.keys(store).length === 0) {
      localStorage.removeItem(GRAPHIC_STORAGE_KEY);
    } else {
      localStorage.setItem(GRAPHIC_STORAGE_KEY, JSON.stringify(store));
    }
    return true;
  } catch (err) {
    console.warn("clearGraphicFromLocalStorage failed:", err);
    return false;
  }
};

/**
 * Nettoie tous les drafts expirés (à appeler au mount).
 */
const cleanupExpiredGraphicDrafts = () => {
  try {
    const raw = localStorage.getItem(GRAPHIC_STORAGE_KEY);
    if (!raw) return 0;

    const store = JSON.parse(raw);
    const now = Date.now();
    let cleaned = 0;

    Object.keys(store).forEach(key => {
      if (store[key]?.expiresAt && store[key].expiresAt < now) {
        delete store[key];
        cleaned++;
      }
    });

    if (cleaned > 0) {
      if (Object.keys(store).length === 0) {
        localStorage.removeItem(GRAPHIC_STORAGE_KEY);
      } else {
        localStorage.setItem(GRAPHIC_STORAGE_KEY, JSON.stringify(store));
      }
    }
    return cleaned;
  } catch {
    return 0;
  }
};


// Product-data problems of ONE checkout line (missing id/image/variant/
// category/options, invalid quantity/price, missing tax info), in the order
// the Pay button reports them. Payment-method checks are order-level and live
// in getPaymentButtonReason. Also used to highlight the faulty product rows.
const isEmptyValue = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  (typeof value === "string" && value.trim() === "");

export const getProductLineIssue = (product) => {
  const isEmpty = isEmptyValue;
  const isEmptyObject = (obj) =>
    !obj || typeof obj !== "object" || Object.keys(obj).length === 0;
  if (!product) return { reason: __elakayText("t030", "Product ID is missing"), action: __elakayText("t031", "Reload the product information before continuing."), type: "error" };
  if (isEmpty(product.productID)) {
    return {
      reason: __elakayText("t030", "Product ID is missing"),
      action: __elakayText("t031", "Reload the product information before continuing."),
      type: "error",
    };
  }

  // ROOT CAUSE (Dropshipping In "Invalid product image"): this required an already-ABSOLUTE
  // http(s) URL -- see isValidProductImage's own comment for why that broke Dropshipping In
  // specifically while native/CJ images (already absolute) always passed.
  if (!isValidProductImage(product.urlImg)) {
    return {
      reason: __elakayText("t032", "Invalid product image"),
      action: __elakayText("t033", "Refresh the product or upload a valid product image."),
      type: "error",
    };
  }

  if (isEmpty(product.filterPro)) {
    return {
      reason: __elakayText("t034", "Product filter reference is missing"),
      action: __elakayText("t035", "Select the product variation before continuing."),
      type: "warn",
    };
  }

  if (isEmpty(product.catID)) {
    return {
      reason: __elakayText("t036", "Product category ID is missing"),
      action: __elakayText("t037", "Reload the product category before continuing."),
      type: "error",
    };
  }

  // Only customer-facing options must be filled: "__cjVariantCode",
  // "__cjSku"... are internal supplier metadata (often legitimately empty).
  const customerOptions = Object.entries(product.filter || {}).filter(([key]) => !key.startsWith("__"));
  if (
    !product.filter ||
    isEmptyObject(product.filter) ||
    customerOptions.some(([, value]) => isEmpty(value))
  ) {
    return {
      reason: __elakayText("t038", "Product options are incomplete"),
      action: __elakayText("t039", "Select all required product options before continuing."),
      type: "warn",
    };
  }

  if (!Number.isInteger(Number(product.count)) || Number(product.count) <= 0) {
    return {
      reason: __elakayText("t040", "Invalid quantity"),
      action: __elakayText("t041", "Select a quantity greater than zero."),
      type: "warn",
    };
  }

  if (typeof product.price !== "number" || product.price <= 0) {
    return {
      reason: __elakayText("t042", "Invalid product price"),
      action: __elakayText("t043", "Refresh the product price before continuing."),
      type: "error",
    };
  }

  if (!product.cat_Product) {
    return {
      reason: __elakayText("t044", "Product category is missing"),
      action: __elakayText("t045", "Reload the product information."),
      type: "error",
    };
  }

  // No client-side tax check: tax comes only from the server checkout quote,
  // which blocks payment itself when it cannot be calculated.
  return null;
};

/* ─── Helpers (logique originale conservée) ─── */

const adressSeleted = (a, b) => {
  let y;
  a && a.filter(It => { if (It[b] === true) y = It; });
  return y;
};

function getDefaultAddress(addresses = []) {
  if (!addresses.length) return null;
  const found = addresses.find(a => a.addressDefault);
  return found || addresses[0];
}

// "Santiago de los Caballeros, 51072, Dominican Republic (DO)" from the
// approximate IP location ({ city, postal_code, country } ISO code).
export const formatIpDefaultAddress = (location) => {
  const code = String(location?.country || "").toUpperCase();
  const countryName = (contries.find((c) => c.code === code) || {}).name;
  const country = countryName ? `${countryName} (${code})` : code;
  return [location?.city, location?.postal_code || location?.postalCode, country].filter(Boolean).join(", ");
};

function checkIfObjectIsEmpty(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  return Object.keys(obj)?.length !== 0;
}

  const simulationPriceBase = {
    ItemsOrder: 0,
    prodDiscount: 0,
    prodPrice: 0,
    prodFrService: 0,
    prodFrVente: 0,
    prodFrRef: 0,
    TaxOrder: 0,
    getTotal: 0,
    prodFrTransaction: 0,
    totalFrais: 0,
    inComeSeller: 0,
    elakayFrais: 0,
    statut: { profit: 0, loss: 0, statut: "break-even point" },
  };

/* ─── Composant principal ─── */
/*
╔════════════════════════════════════════════════════╗
║ COMBINE PAYMENT INTENTS                           ║
║                                                   
║ Combine:
║ - seller / referrerSeller / promotion ...
║ - Family / Admin / Investment / Associate
╚════════════════════════════════════════════════════╝
*/

const combinePaymentIntent = (
  basePaymentIntent = {},
  teamPaymentIntent = {}
) => {

  /*
  ─────────────────────────────────────
  DEFAULT STRUCTURE
  ─────────────────────────────────────
  */

  const DEFAULT_PAYMENT = {
    payment: false,
    amount: 0,
    user_ref: null
  };

  /*
  ─────────────────────────────────────
  ALL POSSIBLE FIELDS
  ─────────────────────────────────────
  */

  const ALL_FIELDS = [

    // seller
    "seller",

    // promo
    "promotion",

    // dropshipping
    "dropshipping_seller",

    // mentor
    "referrerSeller",

    // team
    "FamilyPayment",

    "AdminPayment",

    "InvestmentPayment",

    "AssociatePayment"
  ];

  /*
  ─────────────────────────────────────
  FINAL OBJECT
  ─────────────────────────────────────
  */

  const finalPaymentIntent = {};

  ALL_FIELDS.forEach((field) => {

    const baseValue =
      basePaymentIntent[field] || {};

    const teamValue =
      teamPaymentIntent[field] || {};

    /*
    team priority
    */

    const merged = {

      ...DEFAULT_PAYMENT,

      ...baseValue,

      ...teamValue
    };

    /*
    payment auto
    */

    // merged.payment =
    //   merged.amount > 0;

    finalPaymentIntent[field] = merged;
  });

  return finalPaymentIntent;
};

// Composant interne : doit être rendu à l'intérieur de <Elements> (voir le
// wrapper CheckoutStripeElements plus bas) pour que useStripe() résolve une
// vraie instance Stripe -- nécessaire pour confirmer une autorisation 3D
// Secure (paymentAuthorizations[].status === "requires_action") après la
// création de la commande.
const CheckoutForm = ({
  laguangeElakay,
  infoSource,
  Saddress= { firstName: "", lastName: "", tel: "", city: "", country: "", line1: "", postal_code: "", state: "" },
  setSAddressFinal,
  addressSel,
  products,
  quantity,
  cart = false,
  count,
  feetShip = 1.3,
  graphic = false,
  addressShop,
  buttonAddCart = null,
  // Optional content rendered immediately above the purchase buttons
  // (Product View uses it for the Product Bundles offer).
  aboveActions = null,
  // Location Context destination for the ESTIMATE (Product Preview): the
  // consumer's Target Location or approximate IP location
  // ({ country, state, city, postal_code, source, approximate, label }).
  // Used while no delivery address is chosen -- or, for an explicit Target
  // Location, until the consumer picks/types an address or reaches payment.
  // The order itself always uses the real delivery address (Saddress).
  provisionalDestination = null,
  // Open the existing payment step as soon as its prerequisites (signed in,
  // address, saved card, valid lines) are met -- used by the Combined Offer
  // "Buy Now". When a prerequisite is missing, the usual links are shown.
  autoOpenPayment = false,
  // Render ONLY the existing checkout modal, opened immediately (Combined
  // Offer "Buy Now" reuses the exact same modal as the product Buy Now).
  modalOnly = false,
  onClose = null,
  galeries,
  owner,
  onOrderSuccess = null
}) => {
  __setElakayInfoSource(infoSource);
  const { userInfo } = infoSource;
  const stripe = useStripe();
  const location = useLocation();
  const checkoutReturnUrl = `${location.pathname}${location.search || ""}`;
  const profileAddressUrl = `/profile?addr=1&returnUrl=${encodeURIComponent(checkoutReturnUrl)}`;
  const walletCardUrl = `/wallet?addCard=true&returnUrl=${encodeURIComponent(checkoutReturnUrl)}`;
  const signInUrl = `/signin?returnUrl=${encodeURIComponent(checkoutReturnUrl)}`;
  /* ── Helpers internes ── */
  const checkPhotosSize = (photosArray) => {
    const MAX = 600 * 1024;
    return photosArray.every(p => p.size <= MAX);
  };

  const createArrayNum = (s, e) => {
    const arr = [];
    for (let i = s; i <= e; i++) arr.push(i);
    return arr;
  };

  /* 🆕 Crée un Order draft dès que le modal s'ouvre, pour le mode graphic */
// useEffect(() => {
//   if (!PaymentCh) return;                          // modal fermé
//   if (!products[0]?.graphic) return;               // pas un produit graphic
//   if (draftOrderId) return;                        // déjà créé
//   if (draftLoading) return;                        // en cours

//   setDraftLoading(true);
//   createOrder(
//     { token, pubToken },
//     { ...createOrderDataNew, status: "draft" },
//     true
//   )
//     .then(response => {
//       if (response??._id) {
//         setDraftOrderId(response?._id);
//       } else {
//         setError("Failed to initialize order. Please try again.");
//       }
//     })
//     .catch(err => {
//       console.error("Draft order error:", err);
//       setError(err.message || "Failed to initialize order");
//     })
//     .finally(() => setDraftLoading(false));
// }, [PaymentCh, products, draftOrderId, draftLoading]);

    // 1. Créer un Order DRAFT au mount si graphic
    // 🐛 FIX: cet effect s'exécutait dès le montage de la page (juste en ouvrant
    // /product/preview/:id pour un produit "graphic"), avant toute action de
    // l'utilisateur. `products[0].graphic` à ce stade est le booléen du produit
    // ("ce produit nécessite un graphique"), pas l'objet de données graphique
    // réel — le backend rejette donc systématiquement l'appel avec
    // "Graphic data is required for graphic orders". `draftOrderId` n'est de
    // toute façon consommé que par `openGraffitiConfig`/`handleGraphicConfirm`
    // ci-dessous, qui ne sont jamais appelés ailleurs dans ce composant (le
    // vrai flux graphic passe par `graphicOrderInfo` + `createPaymentIntent`
    // plus bas, correctement gardé par `checkPayBtn`). Désactivé.
  // useEffect(() => {
  //   if (!products[0]?.graphic) return;
  //   if (draftOrderId) return;
  //
  //   createOrder({ token, pubToken }, { ...createOrderDataNew, status: "draft" }, true)
  //     .then(order => setDraftOrderId(order?._id));
  // }, [products]);

  // 2. Ouvrir le configurator avec l'ID
  const openGraffitiConfig = () => {
    if (!draftOrderId) {
      setError(elakayAutoText("h_07108ece172889", "Order draft not ready"));
      return;
    }
    setGraphicConfigOpen(true);
  };

  // 3. Quand le configurator confirme, on submit l'ordre
  const handleGraphicConfirm = async ({ graphicOrderId, sourceType }) => {
    setGraphicConfigOpen(false);
    // Met à jour l'order avec la ref graphic
    
    // await updateOrder(token, draftOrderId, {
    //   status: "pending",
    //   graphicOrderRef: graphicOrderId,
    //   graphicSourceType: sourceType
    // });

    // Continue le flow de paiement normal
    setNextPage(true);
  };

  const payment_right_message = {
    label: __elakayText("t011", "payment_right_message"),
    translations: {
      en: "💳 Order confirmed. Payment authorized, awaiting acceptance by the Seller or delegated Provider. No further payment is needed.",
      fr: "💳 Commande confirmée. Paiement autorisé, en attente d’acceptation par le vendeur ou le provider autorisé. Aucun nouveau paiement n’est nécessaire.",
      ht: "💳 Kòmand konfime. Peman otorize, n ap tann vandè a oswa founisè ki gen pèmisyon an aksepte li. Ou pa bezwen peye ankò.",
      es: "💳 Pedido confirmado. Pago autorizado, pendiente de aceptación por el vendedor o proveedor autorizado. No es necesario volver a pagar.",
      pt: "💳 Pedido confirmado. Pagamento autorizado, aguardando aceitação pelo vendedor ou fornecedor autorizado. Não é necessário pagar novamente."
    }
  };

    const loadSimulationPrice = (ord, ship, pp, pr) => {
      let newInf = {
        ItemsOrder: ItemsOrder([ord]),
        prodDiscount: prodDiscount([ord]),
        prodPrice: prodPrice([ord]),
        prodFrService: prodFrService([ord], 0),
        prodFrVente: prodFrVente([ord], 0),
        prodFrRef: prodFrRef([ord], 0),
        TaxOrder: TaxOrder([ord]),
        getTotal: getTotal([ord], 0),
        prodFrTransaction: prodFrTransaction([ord], 0),
        totalFrais: totalFrais([ord], 0),
        inComeSeller: inComeSeller([ord], 0),
        elakayFrais: elakayFrais([ord], 0),
        statut: calProfit([ord], ship, pp),
      };
  return newInf
    };

  const { obj } = getElakayLang();
  const { code } = obj;

  const getPaymentMessage = (lang = navigator.language.slice(0, 2)) =>
    payment_right_message.translations[lang] || payment_right_message.translations.en;

  /* ── State ── */
  let navigate = useNavigate();
  
  const [draftOrderId, setDraftOrderId] = useState(null);
  const [graphicConfigOpen, setGraphicConfigOpen] = useState(false);
  /* 🆕 Order draft créé en amont pour permettre le save graphic */
// const [draftOrderId, setDraftOrderId] = useState(null);
const [draftLoading, setDraftLoading] = useState(false);
const [prixCreatorDesign, setPrixCreatorDesign] = useState(0);
const [graphicSubmitted, setGraphicSubmitted] = useState(false);
const [graphicOrderInfo, setGraphicOrderInfo] = useState(null);

/* États pour le workflow graphic 2-étapes */
// const [graphicSubmitted, setGraphicSubmitted] = useState(false);
// const [graphicOrderInfo, setGraphicOrderInfo] = useState(null);
const [showGraphicPreview, setShowGraphicPreview] = useState(false);  // 🆕

  const [paymentIntent,  setPaymentIntent] = useState({});
  const [buyerStripeCustomerId, setBuyerStripeCustomerId] = useState(null);
  const buyerPaymentAccountRequest = useRef(null);
  const checkoutInFlight = useRef(false);
  const lastCheckoutBody = useRef(null);
  const [pendingOrderId, setPendingOrderId] = useState(null);
  const [show,               setShow]               = useState(false);
  const [taxprod,            setTaxProd]             = useState({});
  const [laodShip,           setLaodShip]            = useState(true);
  const [laodButton,         setLaodButton]          = useState(false);
  const [PaymentCh,          setPayment]             = useState(false);
  // Checkout modal with several lines: indexes of the lines the buyer unchecked.
  const [excludedLines,      setExcludedLines]       = useState(() => new Set());
  const [addressFinal,       setAddressFinal]        = useState(false);
  const [paymentMethods,     setPaymentMethods]      = useState([]);
  const [savedCardsState,    setSavedCardsState]     = useState({ status: "loading", error: null });
  const [IDpaymentMethods,   setIDPaymentMethods]    = useState('');
  const [nextPage,           setNextPage]            = useState(false);
  const [graphicNote,        setGraphicNote]         = useState('');
  const [designRequest,      setDesignRequest]       = useState("UD");
  const [addImage,           setAddImage]            = useState(false);
  const [addNote,            setAddNote]             = useState(false);
  const [error,              setError]               = useState(null);
  const [message,            setMessage]             = useState({ sms: null, al: 2 });
  const [showModalPaietSMS,  setShowModalPaietSMS]   = useState(false);
  const [success,            setSuccess]             = useState(null);
  const [post, setPost] = useState({ title: "", desc: "", photos: [] });
  const { title, desc, photos } = post;

  const [data, setData] = useState({
    loading: false, success: false, clientToken: null,
    error: "", instance: {}, address: "", redirectToFilter: false
  });

  const [SPM, setSPM] = useState({
    PM_id_sel: null , b_name: null, b_exp_month: null, b_exp_year: null,
    b_city: null, b_brand: null, b_last4: null, b_country: null,
    b_line1: null, b_postal_code: null, b_state: null
  });
  const { PM_id_sel, b_name, b_exp_month, b_exp_year, b_city, b_brand, b_last4, b_country, b_line1, b_postal_code, b_state } = SPM;

  /* ── Payment methods (Payment & Withdrawal Settings) ──
     Stripe card is always offered. PayPal / Google Pay / Apple Pay appear
     only when the Family enabled them (server, AND-ed with provider
     configuration) AND they are available for this device / order. With
     Stripe alone, nothing changes in this checkout. */
  const [allowedMethods, setAllowedMethods] = useState({ stripe: false });
  const [methodAvailability, setMethodAvailability] = useState({ status: "loading", error: null });
  const [paypalClientId, setPaypalClientId] = useState("");
  const [paypalEligible, setPaypalEligible] = useState(false);
  const [paypalChecked, setPaypalChecked] = useState(false);
  const [paymentChoice, setPaymentChoice] = useState(null);
  const pendingPayPalOrders = useRef(new Map());
  useEffect(() => {
    let active = true;
    getAvailablePaymentMethodsAPI()
      .then((res) => {
        if (!active) return;
        setAllowedMethods(res.checkout || { stripe: false });
        setPaypalClientId(res.paypalClientId || "");
        setMethodAvailability({ status: "ready", error: null });
      })
      .catch((availabilityError) => {
        if (!active) return;
        setAllowedMethods({ stripe: false });
        setMethodAvailability({ status: "error", error: availabilityError });
      });
    return () => { active = false; };
  }, [nextPage]);
  useEffect(() => {
    let active = true;
    setPaypalEligible(false);
    setPaypalChecked(!(allowedMethods.paypal && paypalClientId));
    if (allowedMethods.paypal && paypalClientId) {
      isPayPalEligible(paypalClientId)
        .then((ok) => { if (active) setPaypalEligible(ok); })
        .catch(() => { if (active) setPaypalEligible(false); })
        .finally(() => { if (active) setPaypalChecked(true); });
    }
    return () => { active = false; };
  }, [allowedMethods.paypal, paypalClientId]);

  // Destination of the shipping + tax ESTIMATE (see provisionalDestination).
  const [addressTouched, setAddressTouched] = useState(false);
  const { address: estimateAddress, provisional: usingProvisionalDestination } = pickEstimateAddress({
    address: Saddress, provisionalDestination, paymentStep: nextPage, addressTouched,
  });

  /* ── Calculs prix ── */
  // Taxes: an estimate from the estimate destination (an IP location is never
  // a tax jurisdiction proof); the delivery address replaces it as soon as it
  // is chosen.
  // (Shared with the Cart Check-in modal: ./checkoutTotals.js.)
  useEffect(() => {
    let active = true;
    fetchDestinationTax(estimateAddress).then((destinationTax) => {
      if (!active) return;
      setTaxProd(destinationTax);
      if (destinationTax.taxSource && Array.isArray(products)) {
        products.forEach((product) => { product.taxprodZone = destinationTax; });
      }
    });
    return () => { active = false; };
    // Re-fetched when an address field it reads changes (not on every new address object).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimateAddress?.country, estimateAddress?.postal_code, estimateAddress?.postalCode, estimateAddress?.state, estimateAddress?.State, estimateAddress?.stateCode, products]);

  const { token }        = isAuthenticated();
  const { pubToken }     = getUserPUBToken();

  /* ── Shipping (automatic estimate, backend = source of truth) ──
     Real origin (Seller / Provider / supplier) vs the selected delivery
     address, per selected variant and quantity. Re-estimated (debounced)
     when the address, the quantity or the variant changes. */
  const shippingEstimate = useShippingEstimate({
    items: buildEstimateItems(products),
    destination: buildEstimateDestination(estimateAddress),
    token,
  });

  const redicectToFilters = (redirectToFilter) => { if (redirectToFilter && !onOrderSuccess) navigate("/"); };
  const deliveryDay       = (a) => { const d = new Date(); d.setDate(d.getDate() + (a || 0)); return d; };

  // Item subtotal and tax formulas live in ./checkoutTotals.js (also used by
  // the Cart Check-in modal, so its summary always equals this one).
  const ItemsOrder = () => serverQuote.data ? serverQuote.data.itemsCents / 100 : itemsTotal(activeProducts);

  // Only a server-confirmed, chargeable amount is ever added to the total;
  // unknown shipping is never shown/charged as $0 or as "free".
  const ShippingOrder = () => serverQuote.data ? serverQuote.data.shippingCents / 100 : (activeShippingReady ? Number(activeShipping.data.totals.chargeableAmount) || 0 : 0);

 // Tax is never computed here: only the server quote's amount (see
 // ./checkoutTaxDisplay.jsx for how a missing/failed quote is displayed).
 const TaxOrder = () => serverQuote.data ? serverQuote.data.taxCents / 100 : 0;

  const CheckActiveBtn = () => products.reduce((acc, nv) =>
    cart ? (acc + nv.quantity) >= (acc + nv.count) : quantity >= count, 0);

  const getTotal = () => {
    const a = ItemsOrder();
    const b = ShippingOrder() || 0;
    const c = TaxOrder();
    return a + b + c;
  };

  const getAmountTotal = () =>
    serverQuote.data ? serverQuote.data.amountCents / 100 : Number((getTotal() + Number(prixCreatorDesign || 0)).toFixed(2));

  /* ── Stripe / API ── */
  const getCustomersRetrieve = (token) => {
    token && CustomersRetrieve(token).then(data => {
      if (!data || data.error) { }
      else if (data.deleted) { setIDPaymentMethods(null); }
      else { setIDPaymentMethods(data.invoice_settings?.default_payment_method_id || data.invoice_settings?.default_payment_method?.id || data.invoice_settings?.default_payment_method); }
    });
  };

  const Customercreate = (token) => {
    if (!token) { setSavedCardsState({ status: "idle", error: null }); return; }
    setSavedCardsState({ status: "loading", error: null });
    const request = listePM_createStripeCusTomer(token).then(data => {
      if (!data || data.error) {
        setPaymentMethods([]);
        setSavedCardsState({ status: "error", error: data?.error || true });
      }
      else {
        setBuyerStripeCustomerId(data.customerId || null);
        setPaymentMethods(Array.isArray(data?.paymentMethods) ? data.paymentMethods : []);
        setSavedCardsState({ status: "ready", error: null });
        ViewPaymentDefault(token, data?.defaultPaymentMethodId);
      }
      return data;
    }).catch((cardsError) => {
      setPaymentMethods([]);
      setSavedCardsState({ status: "error", error: cardsError });
      return null;
    });
    buyerPaymentAccountRequest.current = request;
    return request;
  };

  // const handleImsOderGraphic = (order_id, photos) => {
  //   photos?.map(f => AddImgGraphicOrder(token, order_id, f.file).then(data => {
  //     if (data.error) { setError(data.error); }
  //     else {
  //       setError(null); setGraphicNote(''); setNextPage(false);
  //       setPost({ title: "", desc: "", photos: [] });
  //     }
  //   }));
  // };

  const handleImsOderGraphic = async (order_id, photos) => {
  if (!photos?.length) return;
  
  // Sequential (UP-08): parallel bursts were refused with 503 by the server.
  const results = [];
  for (const f of photos) {
    try { results.push({ status: "fulfilled", value: await AddImgGraphicOrder(token, order_id, f.file) }); }
    catch (reason) { results.push({ status: "rejected", reason }); }
  }
  
  const errors = results.filter(r => r.status === "rejected" || r.value?.error);
  if (errors.length) {
    setError(elakayAutoText("h_9256152d60a847", "{value0}/{value1} uploads failed", { value0: errors.length, value1: photos.length }));
    return false;
  }
  
  setError(null);
  setGraphicNote("");
  setNextPage(false);
  setPost({ title: "", desc: "", photos: [] });
  return true;
};


  useEffect(() => {
  const load = async () => {
    const data = await getTeamPaymentIntent();
    setPaymentIntent(data);
  };
  load();

}, []);

useEffect(() => {
  const id = setTimeout(() => setLaodButton(true), 2500);
  Customercreate(token);
  getCustomersRetrieve(token);
  return () => clearTimeout(id);
}, []);

  const selectAdress  = () => event => { setAddressTouched(true); addressSelecctId(token, event.target.value); };
  const selectPayment = () => event => ViewPaymentDefault(token, event.target.value);

  const addressSelecctId = (token, adressId) => {
    adressId && getAddressById(token, adressId).then(data => {
      if (!data) { }
      else {
        setSAddressFinal({
          firstName: data[0]?.firstName, lastName: data[0]?.lastName,
          tel: data[0]?.tel,             city: data[0]?.city,
          country: data[0]?.country,     line1: data[0]?.Address1,
          postal_code: data[0]?.postalCode, state: data[0]?.State
        });
      }
    });
  };

  const newCartProd = async (newCart, PM_id_sel) => {
    for (let i = 0; i < newCart?.length; i++) {
      newCart[i].paymentIntent = { ...(newCart[i].paymentIntent || {}), payment_method: PM_id_sel };
    }
  };

  const ViewPaymentDefault = (token, IDpaymentMethods) => {
    IDpaymentMethods && retrievePayment(token, { IDpaymentMethods }).then(data => {
      if (!data) { }
      else {

        newCartProd(products, data?.payment_method?.id);
        setSPM({
          PM_id_sel:    data?.payment_method?.id,
          b_name:       data?.payment_method?.billing_details?.name,
          b_exp_month:  data?.payment_method?.card?.exp_month,
          b_exp_year:   data?.payment_method?.card?.exp_year,
          b_city:       data?.payment_method?.billing_details.address?.city,
          b_brand:      data?.payment_method?.card?.brand,
          b_last4:      data?.payment_method?.card?.last4,
          b_country:    data?.payment_method?.billing_details?.address?.country,
          b_line1:      data?.payment_method?.billing_details?.address?.line1,
          b_postal_code:data?.payment_method?.billing_details?.address?.postal_code,
          b_state:      data?.payment_method?.billing_details?.address?.state
        });
      }
    });
  };

  const { firstName, lastName, tel, city, country, line1, postal_code, state } = Saddress;

  const handleChange = name => event => { setAddressTouched(true); setSAddressFinal({ ...Saddress, [name]: event.target.value }); };

  const backDefault = () => setAddressFinal(false);
// Dropshipping variant of each line (resolved once; an unresolvable variant is
// a line error, see below).
let providerProductError = null;
const providerErrorIndexes = new Set();
const preparedProducts = products.map((product, index) => {
  try {
    return prepareDropshippingOrderProduct(product);
  } catch (variantError) {
    providerProductError = variantError;
    providerErrorIndexes.add(index);
    return product;
  }
});

// A product row has an error: invalid line data, its supplier variant cannot
// be resolved, or it cannot be shipped to this destination. Such rows get a
// pale red background in the order summary.
const blockedShippingIndexes = new Set(
  shippingEstimate.status === "ready"
    ? (shippingEstimate.data?.lines || [])
      .map((l, i) => (SHIPPING_BLOCKING_SOURCES.has(l.cost?.source) ? (Number.isInteger(l.index) ? l.index : i) : -1))
      .filter((i) => i >= 0)
    : []
);
// Lines the server checkout quote refused (POST /order/quote details.lines),
// with the server's reason. Kept while the same products are in the checkout,
// so a removed line does not come back and fail the quote again.
const productsSignature = (Array.isArray(products) ? products : [])
  .map((p) => `${p?.productID}|${p?.filterPro}|${p?.count}|${p?.bundle?.groupId || ""}`).join(",");
const [quoteRefused, setQuoteRefused] = useState(() => new Map());
useEffect(() => { setQuoteRefused(new Map()); }, [productsSignature]);

const productLineHasError = (index) =>
  providerErrorIndexes.has(index)
  || quoteRefused.has(index)
  || blockedShippingIndexes.has(index)
  || Boolean(getProductLineIssue(preparedProducts[index]));

/* ── Line selection in the checkout modal (several lines: Cart Check-in,
   Combined Offer Buy Now). A line with an error is removed automatically;
   the buyer can also uncheck / re-check any line. Only the checked lines are
   priced, shipped, taxed and sent to createOrder -- the unchecked ones are
   simply not bought (a Check-in line then stays in the cart). Lines of one
   combined offer move together (the offer is only valid as a whole). The
   single-product checkout and the cart page summary are unchanged. ── */
const selectableLines = Boolean(modalOnly) && Array.isArray(products) && products.length > 1;
const lineGroupOf = (i) => (products[i]?.bundle?.groupId ? String(products[i].bundle.groupId) : null);
const groupIndexesOf = (i) => {
  const group = lineGroupOf(i);
  return group ? products.map((_, k) => (lineGroupOf(k) === group ? k : -1)).filter((k) => k >= 0) : [i];
};
const lineAutoRemoved = (i) => selectableLines && groupIndexesOf(i).some(productLineHasError);
// Cart page (no line selection): a line the server refused is left out of the
// quote so the summary still shows the other lines' tax and total, but Pay is
// blocked (see refusedCartLinesBlock) -- this checkout pays the whole cart.
const cartLinesRefused = !selectableLines && quoteRefused.size > 0;
const lineActive = (i) => (selectableLines ? (!excludedLines.has(i) && !lineAutoRemoved(i)) : !quoteRefused.has(i));
const activeIndexes = (Array.isArray(products) ? products : []).map((_, i) => i).filter(lineActive);
const activeProducts = (selectableLines || cartLinesRefused) ? activeIndexes.map((i) => products[i]) : products;
const activeShipping = (selectableLines || cartLinesRefused) ? selectShippingEstimate(shippingEstimate, activeIndexes) : shippingEstimate;
// A boolean on purpose: it is a dependency of the quote effect below, and in
// multi-line mode selectShippingEstimate builds a NEW totals object on every
// render -- as an object it re-ran the effect (aborting the debounced quote)
// on every render, so a Combined Offer / Check-in quote never arrived.
const activeShippingReady = activeShipping.status === "ready" && Boolean(activeShipping.data?.totals);
// The quote waits for the estimate to SETTLE (it reuses the live rates the
// estimate just fetched), not for it to succeed: a failed estimate must not
// leave the tax "Calculating…" forever -- the quote prices shipping itself.
const activeShippingSettled = activeShippingReady || activeShipping.status === "error";
const [serverQuote, setServerQuote] = useState({ status: "idle", data: null });
const quoteBody = JSON.stringify({ products: activeProducts, shippingAddress: Saddress });
// Product index of each quoted line (the quote only receives active lines).
const quotedIndexesRef = useRef([]);
quotedIndexesRef.current = activeIndexes;
useEffect(() => {
  const quotedIndexes = quotedIndexesRef.current;
  if (!token || !activeShippingSettled) { setServerQuote({ status: "idle", data: null }); return undefined; }
  const controller = new AbortController();
  setServerQuote({ status: "loading", data: null });
  const timer = setTimeout(() => {
    quoteCheckoutAPI(JSON.parse(quoteBody), { signal: controller.signal, headers: pubToken ? { UserPUBToken: `Bearer ${pubToken}` } : {} })
      .then(result => setServerQuote({ status: "ready", data: result }))
      .catch(err => {
        if (err.name === "AbortError") return;
        // The server names the refused line(s): mark them (removed
        // automatically when lines are selectable) instead of failing the
        // tax and total of every other product.
        const refused = (err.details?.lines || [])
          .map((l) => ({ index: quotedIndexes[l.index], reason: l.error }))
          .filter((l) => Number.isInteger(l.index));
        if (refused.length) setQuoteRefused((prev) => new Map([...prev, ...refused.map((l) => [l.index, l.reason])]));
        const names = refused.map((l) => products[l.index]?.name).filter(Boolean);
        const reason = taxErrorReason(err.code) || err.message;
        // A refusal for shipping still carries the tax (details.tax): the
        // Tax row keeps its amount, the total and Pay stay blocked.
        setServerQuote({ status: "error", data: null, error: names.length ? `${names.join(", ")}: ${refused[0].reason || reason}` : reason, code: err.code, tax: err.details?.tax || null });
      });
  }, 300);
  return () => { clearTimeout(timer); controller.abort(); };
}, [token, pubToken, quoteBody, activeShippingSettled]);

const activeProviderError = selectableLines
  ? (activeIndexes.some((i) => providerErrorIndexes.has(i)) ? providerProductError : null)
  : providerProductError;
const autoRemovedCount = selectableLines ? products.filter((_, i) => lineAutoRemoved(i)).length : 0;
const toggleLine = (i) => setExcludedLines((prev) => {
  const next = new Set(prev);
  const include = next.has(i);
  groupIndexesOf(i).forEach((k) => (include ? next.delete(k) : next.add(k)));
  return next;
});
// Why a line was removed automatically (shown under its name).
const lineErrorReason = (i) => {
  const issue = getProductLineIssue(preparedProducts[i]);
  if (issue) return issue.reason;
  if (blockedShippingIndexes.has(i)) {
    const line = (shippingEstimate.data?.lines || []).find((l, k) => (Number.isInteger(l.index) ? l.index : k) === i);
    return blockedLineMessage(line, shippingEstimate.data?.destination?.country);
  }
  if (providerErrorIndexes.has(i)) return elakayAutoText("h_ckout_variant_unavailable", "This product option is no longer available.");
  if (quoteRefused.has(i)) return quoteRefused.get(i) || elakayAutoText("h_ckout_variant_unavailable", "This product option is no longer available.");
  if (lineAutoRemoved(i)) return elakayAutoText("h_ckout_removed_with_offer", "Removed with its combined offer.");
  return null;
};

const ordCheckPrice = {
     products: products[0],  
     cat_Product: products[0].cat_Product,
     amountTotal: getAmountTotal().toFixed(2),
     shippingAddress: Saddress,
     taxprodZone: products[0].taxprodZone,
    shipping_amount_local: ShippingOrder(),
    Delivered: deliveryDay()
  } 
  
const allPrice = loadSimulationPrice(ordCheckPrice, 0, 0, 0)
 const  paymentIntentSeReFS =  { seller : {
      payment: false,
      amount: allPrice.inComeSeller,
      user_ref: owner?._id
    }, referrerSeller: {
      payment: false,
      amount: (allPrice.elakayFrais - 0.50) * 0.3333333,
      user_ref:  owner?.userActiveRole?.userAdmin
    },
  }


 const PaymentIntent_ = combinePaymentIntent(
  paymentIntent?.paymentIntent,
  paymentIntentSeReFS
);

const productsWithPaymentIntent = preparedProducts.map((preparedProduct, index) => {
  const product = products[index];
  return ({
  ...preparedProduct,
  paymentIntent: {
    ...(product.paymentIntent || {}),
    ...PaymentIntent_,
    // 🆕 Auto-résout "No payment method selected" : si le produit n'a pas encore
    // reçu le moyen de paiement (ex: race condition au chargement), on retombe
    // sur celui déjà sélectionné/par défaut (SPM) plutôt que de bloquer le paiement.
    customer: buyerStripeCustomerId || userInfo?.StripeCustomerId || undefined,
    payment_method: SPM?.PM_id_sel || product.paymentIntent?.payment_method || undefined,
  }
  });
});
const activeProductsWithPaymentIntent = selectableLines ? activeIndexes.map((i) => productsWithPaymentIntent[i]) : productsWithPaymentIntent;

// Device-level availability of Apple Pay / Google Pay (Stripe canMakePayment).
const walletAvailability = useWalletAvailability(
  Math.round((Number(getAmountTotal()) || 0) * 100),
  Boolean(allowedMethods.googlePay || allowedMethods.applePay)
);
// Custom-design orders keep their dedicated card flow (draft + upload);
// Dropshipping In orders are refused for PayPal by the server.
const checkoutMethods = displayableCheckoutMethods(allowedMethods, {
  paypal: paypalEligible && !products?.[0]?.graphic,
  googlePay: walletAvailability.googlePay,
  applePay: walletAvailability.applePay,
});
const selectedPaymentMethod = resolveSelectedMethod(paymentChoice, checkoutMethods);
const hasAlternativeMethods = checkoutMethods.length > 1;

const createOrderDataNew = {
  products: activeProductsWithPaymentIntent,

  amountTotal: getAmountTotal().toFixed(2),

  shippingAddress: Saddress,

  shipping_amount_local: ShippingOrder(),

  // What the buyer saw -- the server recomputes and refuses the order
  // (SHIPPING_CHANGED) if its own value differs; it never charges this one.
  expectedAmountCents: serverQuote.data?.amountCents,
  expectedShippingCents: activeShippingReady ? activeShipping.data.totals.chargeableCents : 0,

  Delivered: deliveryDay()
};

// const PaymentIntent_ = combinePaymentIntent(paymentIntent?.paymentIntent, paymentIntentSeReFS)

  // const createPaymentIntent = async () => {
  //   if (products[0].graphic) {
  //     let messageOrder = [];
  //     graphicNote && messageOrder.push({ custormer: graphicNote });
  //     photos?.length > 0 && messageOrder.push({ custormer: [0, photos?.length] });
  //     createOrderDataNew['messageOrder'] = messageOrder;
  //   }

  //   token && await createOrder({ token, pubToken }, createOrderDataNew, products[0].graphic)
  //     .then(response => {
  //       if (products[0].graphic) handleImsOderGraphic(response?._id, photos);
  //       setData({ loading: false, redirectToFilter: true, success: true });
  //     })
  //     .catch(error => { setData({ loading: false }); });
  // };

//   const createPaymentIntent = async () => {
//   if (!token) return;

//   /* 🆕 Construire le products avec graphic intégré */
//   const finalProducts = productsWithPaymentIntent.map((product, i) => {
//     /* Si c'est le produit graphic et qu'on a les données, on les attache */
//     if (i === 0 && product.graphic && graphicOrderInfo) {
//       return {
//         ...product,
//         graphic: {
//           /* Le type de source choisi par l'acheteur */
//           sourceType: graphicOrderInfo.sourceType,

//           /* Pour "custom" et "template avec customisation" : 
//              les slots complets avec texts/layers/instructions */
//           slots: graphicOrderInfo.slots || [],

//           /* Pour "template" : l?._id du template du vendeur */
//           templateRef: graphicOrderInfo.templateRef || null,
//           templateMeta: graphicOrderInfo.templateMeta || null,

//           /* Pour "ask" : les données du formulaire */
//           askSellerData: graphicOrderInfo.askSellerData || null,

//           /* Métadonnées */
//           submittedAt: graphicOrderInfo.submittedAt
//         }
//       };
//     }
//     return product;
//   });

//   /* Construire le messageOrder si présent */
//   let messageOrder = [];
//   if (products[0].graphic) {
//     graphicNote && messageOrder.push({ custormer: graphicNote });
//     photos?.length > 0 && messageOrder.push({ custormer: [0, photos?.length] });
//   }

//   const finalOrderData = {
//     ...createOrderDataNew,
//     products: finalProducts,
//     ...(messageOrder.length > 0 && { messageOrder })
//   };

//   try {
//     const response = await createOrder(
//       { token, pubToken }, 
//       finalOrderData, 
//       products[0].graphic
//     );

//     if (products[0].graphic && photos?.length > 0) {
//       handleImsOderGraphic(response?._id, photos);
//     }

//     /* 🆕 Cleanup localStorage après succès du backend */
//     if (products[0]?.productID) {
//       clearGraphicFromLocalStorage(products[0].productID);
//     }

//     /* Reset des states graphic */
//     setGraphicSubmitted(false);
//     setGraphicOrderInfo(null);

//     setData({ loading: false, redirectToFilter: true, success: true });
//   } catch (error) {
//     console.error("[createOrder] Failed:", error);
//     setData({ loading: false });
//     setError(error.message || "Failed to create order");
//   }
// };
// Successful order creation is independent of payment authorization.
const completeOrderSuccess = (response) => {
  setData({ loading: false, redirectToFilter: true, success: true });
  setPayment(false);
  // The created order (its _id and per-line payment results) -- the Cart
  // Check-in uses it to remove only the paid lines from the cart.
  onOrderSuccess && onOrderSuccess(response);
};

let finalData
// Same order pipeline for every method. `paymentProvider: "paypal"` asks the
// server for a PayPal order (authorized after the buyer approves);
// `paymentMethodOverride` carries an Apple Pay / Google Pay PaymentMethod
// already verified + attached server-side (POST /payments/wallet-method).
const createPaymentIntent = async (options = {}) => {
  const { paymentProvider = selectedPaymentMethod === "paypal" ? "paypal" : "stripe", paymentMethodOverride = null } = options;
  if (!token) {
    console.warn("[createPaymentIntent] No token, abort");
    return;
  }

  if (activeProviderError) {
    setError(activeProviderError.message);
    setData(current => ({ ...current, loading: false }));
    return false;
  }

  /* ─── 1. Détection si c'est un graphic order ─── */
  const isGraphicOrder = !!products[0]?.graphic;

  /* ─── 2. Construire les products avec graphic intégré ─── */
  const finalProducts = activeProductsWithPaymentIntent.map((product, i) => {

    /* Si c'est un produit standard (sans graphic), on le retourne tel quel
       mais on s'assure que graphic est null (pas le booléen) */
    if (i !== 0 || !isGraphicOrder) {
      return {
        ...product,
        graphic: null   /* 🆕 force null pour éviter Cast Error côté backend */
      };
    }

    /* Si c'est le produit graphic mais qu'on n'a pas de data → erreur logique */
    if (!graphicOrderInfo) {
      console.warn("[createPaymentIntent] Graphic product but no graphicOrderInfo");
      return {
        ...product,
        graphic: null
      };
    }

    /* 🆕 Construction du graphic complet selon sourceType */
    const graphicData = {
      sourceType: graphicOrderInfo.sourceType,

      /* Pour "custom" et "template avec customisation" */
      slots: graphicOrderInfo.slots || [],

      /* Pour "template" : l'_id du template vendeur (REQUIS si sourceType=template) */
      templateRef: graphicOrderInfo.templateRef || null,
      templateMeta: graphicOrderInfo.templateMeta || null,

      /* Pour "ask" : données du formulaire */
      askSellerData: graphicOrderInfo.askSellerData || null,

      /* Métadonnées */
      submittedAt: graphicOrderInfo.submittedAt || new Date().toISOString()
    };

    return {
      ...product,
      graphic: graphicData
    };
  });

  /* ─── 3. Construire messageOrder si présent (legacy support) ─── */
  let messageOrder = [];
  if (isGraphicOrder) {
    if (graphicNote) {
      messageOrder.push({ custormer: graphicNote });
    }
    if (photos?.length > 0) {
      messageOrder.push({ custormer: [0, photos.length] });
    }
  }

  /* ─── 3bis. Moyen de paiement choisi (jamais le montant : recalculé serveur) ─── */
  const finalProductsWithMethod = finalProducts.map((product) => {
    if (paymentProvider === "paypal") {
      return { ...product, paymentIntent: { ...(product.paymentIntent || {}), customer: null, payment_method: null } };
    }
    if (paymentMethodOverride?.id) {
      return { ...product, paymentIntent: { ...(product.paymentIntent || {}), customer: paymentMethodOverride.customer, payment_method: paymentMethodOverride.id } };
    }
    return product;
  });

  /* ─── 4. Construire le payload final ─── */
  const finalOrderData = {
    ...createOrderDataNew,
    products: finalProductsWithMethod,
    ...(messageOrder.length > 0 && { messageOrder }),
    ...(paymentProvider === "paypal" ? { paymentProvider: "paypal" } : {})
  };
finalData = finalOrderData
  lastCheckoutBody.current = finalOrderData;
  /* ─── 5. Envoyer au backend ─── */
  if (checkoutInFlight.current || pendingOrderId) return false;
  checkoutInFlight.current = true;
  try {
    setData(current => ({ ...current, loading: true }));
    setMessage({ sms: null, al: 2 }); setError(null);
    const response = await createOrder(
      { token, pubToken },
      finalOrderData,
      isGraphicOrder   /* 🆕 Booléen simple — pas l'objet entier */
    );

    /* Si l'API renvoie un objet d'erreur (success: false) */
    if (response?.success === false) {
      throw Object.assign(new Error(response.error || "Order creation failed"), { code: response.code });
    }

    /* Vérification que l'order a bien été créé */
    if (!response?._id) {
      // Never log the full response here -- it can carry payment
      // authorizations (Stripe clientSecret) alongside the order/customer data.
      throw new Error(elakayAutoText("h_02051fdb201df9", "Failed to create order"));
    }

    setPendingOrderId(response._id);
    // Order creation is complete. Payment is handled when the responsible
    // Seller/Provider processes this saved order.
    /* ─── 6. Upload des photos legacy si présentes (mode ask) ─── */
    if (isGraphicOrder && photos?.length > 0 && response?._id) {
      try {
        await handleImsOderGraphic(response._id, photos);
      } catch (uploadErr) {
        console.warn("[createPaymentIntent] Photos upload failed:", uploadErr);
        /* Pas bloquant : l'order est créé */
      }
    }

    /* ─── 7. Cleanup localStorage après succès ─── */
    if (products[0]?.productID) {
      clearGraphicFromLocalStorage(products[0].productID);
    }

    /* ─── 8. Reset des states graphic ─── */
    setGraphicSubmitted(false);
    setGraphicOrderInfo(null);

    /* ─── 9. Succès ─── */
    if (paymentProvider === "paypal") {
      if (!response.paypalOrderId) throw new Error(elakayAutoText("h_pay_unavailable", "Payment is currently unavailable."));
      pendingPayPalOrders.current.set(response.paypalOrderId, response);
      return response.paypalOrderId;
    }
    if (response.checkoutReplayed) {
      setData({ loading: false, redirectToFilter: false, success: true });
      setMessage({ sms: orderText('created'), al: 2 });
    } else completeOrderSuccess(response);
    return true;

  } catch (error) {
    console.error("[createPaymentIntent] Failed:", error);
    setData(prev => ({ ...prev, loading: false }));
    if (error.code === "PAYPAL_NOT_AVAILABLE_FOR_ORDER" || error.code === "PAYMENT_METHOD_UNAVAILABLE") {
      const unavailable = paymentErrorMessage(error);
      setError(unavailable);
      setMessage({ sms: unavailable, al: 1 });
      return false;
    }
    if (error.code === "SHIPPING_CHANGED") {
      shippingEstimate.refresh();
      const changed = elakayAutoText("h_shipest_changed", "The shipping cost changed. Please review your order before paying.");
      setError(changed);
      setMessage({ sms: changed, al: 1 });
      return false;
    }
    // The server's final recalculation found no valid rate for this address
    // (or no delivery to this country): show it, refresh the estimate.
    if (error.code === "SHIPPING_RATE_UNAVAILABLE" || error.code === "DESTINATION_NOT_AVAILABLE") {
      shippingEstimate.refresh();
      const blocked = error.code === "SHIPPING_RATE_UNAVAILABLE"
        ? elakayAutoText("h_salesim_rate_unavailable", "We could not calculate a valid shipping rate for this address.")
        : elakayAutoText("h_salesim_cannot_deliver", "This product cannot currently be delivered to your selected destination.");
      setError(blocked);
      setMessage({ sms: blocked, al: 1 });
      return false;
    }
    // Shown in the modal (the `error` state alone is never rendered): a
    // declined card, a changed price/stock or cart must not fail silently.
    const failure = error.message || elakayAutoText("h_02051fdb201df9", "Failed to create order");
    setError(failure);
    setMessage({ sms: failure, al: 1 });
    return false;
  } finally {
    checkoutInFlight.current = false;
    setData(current => ({ ...current, loading: false }));
  }
};

  // const buttonCheckout = () => {
  //   createPaymentIntent();
  //   setPayment(false);
  //   setShowModalPaietSMS(true);
  //   setSuccess(orderText('created'));
  //   setTimeout(() => setShowModalPaietSMS(false), 8000);
  // };

const finishCheckoutAttempt = (success) => {
  if (!success) return;
  /* Reset graphic only after an order has actually been saved. */
  setDraftOrderId(null);
  setGraphicSubmitted(false);
  setGraphicOrderInfo(null);
  setPrixCreatorDesign(0);

  if (!success) return;

  setShowModalPaietSMS(true);
  setSuccess(orderText('created'));
  setTimeout(() => setShowModalPaietSMS(false), 8000);
};

const buttonCheckout = async (event) => {
  if (checkoutInFlight.current || pendingOrderId) return;
  if (event?.currentTarget) event.currentTarget.disabled = true;
  // createPaymentIntent() est async et peut échouer (carte refusée, 3DS
  // échoué, customer/payment_method manquant) -- afficher la confirmation de
  // succès avant de connaître le résultat trompait l'utilisateur en lui
  // montrant "paiement réussi" même quand l'autorisation avait échoué.
  const success = await createPaymentIntent();
  finishCheckoutAttempt(success);
};

/* ── Apple Pay / Google Pay (Stripe Payment Request) ──
   The wallet's PaymentMethod is verified + attached SERVER-side, then the
   unchanged order pipeline authorizes it. true only when Elakay confirmed. */
const payWithWallet = async (walletKey, paymentMethodId) => {
  setMessage({ sms: null, al: 2 }); setError(null);
  if (!paymentMethodId) return false;
  try {
    const attached = await attachWalletMethodAPI({ paymentMethodId, method: walletKey === "applePay" ? "apple_pay" : "google_pay" });
    const success = await createPaymentIntent({ paymentMethodOverride: { id: attached.paymentMethodId, customer: attached.customer } });
    finishCheckoutAttempt(success);
    return success;
  } catch (walletError) {
    const failure = paymentErrorMessage(walletError);
    setError(failure);
    setMessage({ sms: failure, al: 1 });
    return false;
  }
};

/* ── PayPal ── */
const createPayPalElakayOrder = async () => {
  setMessage({ sms: null, al: 2 }); setError(null);
  const paypalOrderId = await createPaymentIntent({ paymentProvider: "paypal" });
  return typeof paypalOrderId === "string" ? paypalOrderId : null;
};

const approvePayPalOrder = async (paypalOrderId) => {
  try {
    const authorized = await authorizePayPalOrderAPI(paypalOrderId);
    if (authorized.status !== "authorized") throw new Error(elakayAutoText("h_pay_pending", "Payment is awaiting provider confirmation. Check your order before retrying."));
    const response = pendingPayPalOrders.current.get(paypalOrderId) || {};
    pendingPayPalOrders.current.delete(paypalOrderId);
    completeOrderSuccess(response);
    finishCheckoutAttempt(true);
    return { ok: true };
  } catch (paypalError) {
    if (paypalError.code === "PAYPAL_INSTRUMENT_DECLINED") return { restart: true };
    const failure = paymentErrorMessage(paypalError);
    setError(failure);
    setMessage({ sms: failure, al: 1 });
    return { ok: false };
  }
};

const cancelPayPalOrder = (paypalOrderId) => {
  if (!paypalOrderId) return;
  pendingPayPalOrders.current.delete(paypalOrderId);
  cancelPayPalOrderAPI(paypalOrderId).catch(() => { /* closed later by the server cleanup */ });
};

  const validateOrder = () => {
    setMessage({ sms: null, al: 2 }); setError(null);
    if (designRequest === "UD" && designRequest !== "ED") {
      if (photos?.length === 0) { setError(elakayAutoText("h_f6244c2d458055", "Vous devez télécharger au moins une image avant de payer.")); return false; }
      else if (!checkPhotosSize(photos)) { setError(elakayAutoText("h_59750f0bb2e0df", "Certaines photos dépassent 600 KB. Veuillez utiliser des images plus légères.")); return false; }
      else if (graphicNote === '') { setMessage({ sms: elakayAutoText("h_a5a492e6f1b6bc", "Vous pouvez ajouter une note si vous le souhaitez, sinon soumettez votre paiement."), al: 1 }); return true; }
    }
    if (graphicNote === '' && designRequest === "CD" && designRequest !== "ED") {
      setError(elakayAutoText("h_4a85f3e71fa58e", "Veuillez décrire le design graphique que vous souhaitez.")); return false;
    }
    return true;
  };

/* ══════════════════════════════════════════════════════
   checkPayBtn — vérifie si le Payment_Button peut être actif
   
   Conditions communes (toujours requises) :
   - Au moins 1 produit dans la commande
   - Payment method sélectionné pour chaque produit
   - Adresse complète
   
   Conditions supplémentaires si produit graphic :
   - graphicSubmitted = true (l'étape 1 doit être validée)
   - graphicOrderInfo doit contenir des données valides selon sourceType
══════════════════════════════════════════════════════ */

const checkPayBtn = () => {

  /* ─── Conditions de base ─── */
  const pro = createOrderDataNew.products?.length > 0;

  const cusStriID = createOrderDataNew.products.every(
    p => p.paymentIntent.payment_method !== ''
  );

  const AdressTrue = 
    firstName    !== "" && 
    lastName     !== "" && 
    tel          !== "" && 
    city         !== "" && 
    country      !== "" && 
    line1        !== "" && 
    postal_code  !== "" && 
    state        !== "";

  const baseValid = pro && AdressTrue;

  /* ─── Si pas un produit graphic → conditions de base suffisent ─── */
  if (!products[0]?.graphic) {
    return baseValid;
  }

  /* ─── Produit graphic : étape 1 doit être validée ─── */
  if (!graphicSubmitted) return false;
  if (!graphicOrderInfo) return false;

  const sourceType = graphicOrderInfo.sourceType;

  /* ─── MODE CUSTOM : au moins 1 data form (text, image ou background) ─── */
  if (sourceType === "custom") {
    const slots = graphicOrderInfo.slots || [];
    if (slots.length === 0) return false;

    const hasAnyData = slots.some(slot => {

      /* Background */
      const hasBackground = slot.url
        && typeof slot.url === "string"
        && slot.url.trim().length > 0
        && !slot.url.startsWith("blob:")
        && !slot.url.startsWith("data:");
      if (hasBackground) return true;

      /* Texts avec content non vide */
      const texts = slot.slotState?.texts || [];
      const hasText = texts.some(t =>
        t && typeof t.content === "string" && t.content.trim().length > 0
      );
      if (hasText) return true;

      /* Layers avec image valide */
      const layers = slot.slotState?.layers || [];
      const hasLayer = layers.some(l => {
        if (!l) return false;
        const url = l.urlImg || l.src || l.url || "";
        return url
          && typeof url === "string"
          && url.length > 0
          && !url.startsWith("blob:")
          && !url.startsWith("data:");
      });
      if (hasLayer) return true;

      return false;
    });

    return baseValid && hasAnyData;
  }

  /* ─── MODE ASK : au moins 1 champ rempli ─── */
  if (sourceType === "ask") {
    const ask = graphicOrderInfo.askSellerData || {};

    const hasNonEmptyString = (s) => 
      typeof s === "string" && s.trim().length > 0;

    const hasAnyData = (
      hasNonEmptyString(ask.specialInstructions)  ||
      hasNonEmptyString(ask.artistMessage)        ||
      hasNonEmptyString(ask.avoidInstructions)    ||
      hasNonEmptyString(ask.requiredInstructions) ||
      hasNonEmptyString(ask.detailLevel)          ||
      hasNonEmptyString(ask.budget)               ||
      (ask.desiredDate && ask.desiredDate.toString().trim().length > 0) ||
      (Array.isArray(ask.stylePrefs)   && ask.stylePrefs.length > 0)   ||
      (Array.isArray(ask.inspirations) && ask.inspirations.length > 0) ||
      (Array.isArray(ask.refs) && ask.refs.some(r => r && hasNonEmptyString(r)))
    );

    return baseValid && hasAnyData;
  }

  /* ─── MODE TEMPLATE : templateRef requis (ObjectId valide) ─── */
  if (sourceType === "template") {
    const templateRef = graphicOrderInfo.templateRef;
    if (!templateRef) return false;

    const isValidId = typeof templateRef === "string"
      && /^[a-f0-9]{24}$/i.test(templateRef);

    return baseValid && isValidId;
  }

  /* sourceType inconnu */
  return false;
};

  const checkNextPage = () => {
    if (designRequest !== "ED") {
      if (designRequest === "CD") return graphicNote !== '';
      if (designRequest === "UD") return photos?.length > 0;
    }
    return true;
  };

  const btnCustomShooseen = (SH) => { setDesignRequest(SH); setAddImage(false); setAddNote(false); };

  const bntAllFontPayment = (preferredMethod) => {
    if (typeof preferredMethod === "string") setPaymentChoice(preferredMethod);
    setPayment(true);
    Customercreate(token);
    getCustomersRetrieve(token);
    ViewPaymentDefault(token, IDpaymentMethods);
    newCartProd(products, PM_id_sel);
  };

  const autoOpenedRef = useRef(false);
  useEffect(() => {
    if (!autoOpenPayment || autoOpenedRef.current || !laodButton) return;
    if (!isAuthenticated() || !Saddress?.country) return;
    if (!(products?.length > 0 && checkIfObjectIsEmpty(addressShop) && CheckActiveBtn())) return;
    autoOpenedRef.current = true;
    bntAllFontPayment();
  }, [autoOpenPayment, laodButton, Saddress?.country, paymentMethods]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (modalOnly) bntAllFontPayment();
  }, [modalOnly]); // eslint-disable-line react-hooks/exhaustive-deps


  /* ══════════════════════════════════════════════════════
   🆕 handleAddToCartFromGraffiti
   
   Reçu du GraffitiConfigurator au clic sur "Checkout".
   - Stocke le payload en state (pour l'utiliser au Payment_Button)
   - Stocke aussi en localStorage (déjà fait par le configurator,
     mais on garde une copie au cas où)
   - Active graphicSubmitted → step 2 affichée
══════════════════════════════════════════════════════ */
const handleAddToCartFromGraffiti = (data) => {
  if (!data) {
    setError(elakayAutoText("h_0e487c03f66a53", "Invalid graphic data received"));
    return;
  }

  if (!data.sourceType) {
    setError(elakayAutoText("h_94a34d948dd001", "Missing sourceType from configurator"));
    return;
  }

  if (!products[0]?.productID) {
    setError(elakayAutoText("h_f1d8b248660312", "Product ID missing"));
    return;
  }

  /* Stockage en state pour l'utiliser dans createOrderDataNew */
  setGraphicOrderInfo({
    sourceType: data.sourceType,
    /* Pour "custom" et "template avec customisation" */
    slots: data.slots || [],
    /* Pour "template" */
    templateRef: data.templateRef || null,
    templateMeta: data.templateMeta || null,
    /* Pour "ask" */
    askSellerData: data.askSellerData || null,
    /* Variant info */
    variant: data.variant,
    qty: data.qty,
    totalPrice: data.totalPrice,
    submittedAt: new Date().toISOString()
  });

  /* Activation de l'étape 2 */
  setGraphicSubmitted(true);

  /* Feedback */
  setMessage({
    sms: elakayAutoText("h_3ce03e29056c16", "Design saved. Complete shipping and payment to confirm your order."),
    al: 0
  });

  /* Scroll vers le haut */
  const modalBody = document.querySelector(".modal-body");
  if (modalBody) modalBody.scrollTop = 0;
};
  /* ════════════════════════════════════════════
     RENDU — Design "Luxury Commerce"
  ════════════════════════════════════════════ */
 
  /* ── Résumé commande ── */
  /* Spinner inline réutilisable pour les valeurs en attente */
const SpinValue = () => (
  <span style={{
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    color: 'var(--elakay-primary-light)',
    fontSize: '0.85rem',
    fontWeight: 600,
  }}>
    <span style={{
      display: 'inline-block',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      border: '2px solid var(--ck-border)',
      borderTopColor: 'var(--elakay-primary)',
      animation: 'ck-spin 0.7s linear infinite'
    }} />
    <span style={{ opacity: 0.45, letterSpacing: '0.1em' }}></span>
  </span>
);

  /* ── Résumé commande ── */
  // Several lines (Combined Offer Buy Now, cart): list each product with its
  // own quantity, chosen options and price. A single product keeps the
  // original compact summary.
  const multiLine = Array.isArray(products) && products.length > 1;
  // A single line handed over without a `count` prop (cart Check-in) uses its own count.
  const itemsCount = multiLine ? activeProducts.reduce((n, p) => n + (Number(p?.count) || 0), 0) : (count ?? products?.[0]?.count);
  // highlightErrors: inside the checkout modal only, rows of products with an
  // error get a pale red background.
  // showLineList: the per-product list above "Items (n)". The cart page's own
  // summary starts at "Items" (the cart cards already list the products);
  // the checkout modal (Item Details) keeps it.
  const OrderSummaryTable = ({ highlightErrors = false, showLineList = true }) => (
    <div className="ck-summary">
      {multiLine && showLineList && (
        <>
        {/* Inside the checkout modal: products with an error were removed automatically. */}
        {highlightErrors && autoRemovedCount > 0 && (
          <p className="ck-lines-notice" role="status" data-testid="ck-auto-removed">
            {elakayAutoText("h_ckout_auto_removed", "{count} product(s) with an error were removed from this checkout.", { count: autoRemovedCount })}
          </p>
        )}
        <ul className="ck-summary__items" style={{ listStyle: "none", padding: 0, margin: "0 0 0.75rem" }}>
          {products.map((p, i) => {
            const selectable = highlightErrors && selectableLines;
            const autoRemoved = selectable && lineAutoRemoved(i);
            const active = !selectable || lineActive(i);
            const refusedHere = cartLinesRefused && quoteRefused.has(i);
            const reason = (autoRemoved || refusedHere) ? lineErrorReason(i) : null;
            return (
            <li key={`${p.productID}-${p.filterPro || i}`} className={`ck-summary__item${(highlightErrors && (productLineHasError(i) || autoRemoved)) || refusedHere ? " ck-line--error" : ""}${active ? "" : " ck-line--excluded"}`} data-testid="ck-summary-item" style={{ display: "flex", justifyContent: "space-between", gap: "0.75rem", padding: "0.4rem 0", borderBottom: "1px solid #daeaf5", fontSize: "0.88rem" }}>
              {selectable && (
                <input
                  type="checkbox"
                  className="ck-line-check"
                  checked={active}
                  disabled={autoRemoved}
                  onChange={() => toggleLine(i)}
                  aria-label={elakayAutoText("h_ckout_line_select", "Include {product} in this checkout", { product: p.name || p.productName || "" })}
                />
              )}
              <span style={{ minWidth: 0, flex: 1 }}>
                <strong style={{ display: "block", overflowWrap: "anywhere" }}>{p.name || p.productName || ""}</strong>
                {Object.entries(p.displayFilters || {}).map(([k, v]) => (
                  <span key={k} style={{ display: "inline-block", marginRight: "0.6rem", color: "#5a7a8a", textTransform: "capitalize" }}>{k}: {String(v)}</span>
                ))}
                <span style={{ color: "#5a7a8a" }}>× {Number(p.count) || 0}</span>
                {reason && <span className="ck-line-reason">{reason}</span>}
              </span>
              <span style={{ whiteSpace: "nowrap", fontWeight: 600 }}>
                {((Number(p.count) || 0) * (Number(p.price) || 0) * (100 - (Number(p.salePrice) || 0)) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
              </span>
            </li>
            );
          })}
        </ul>
        </>
      )}
 
      {/* Items — disponible immédiatement (single product: its own row) */}
      <div className={`ck-summary__row${highlightErrors && !multiLine && products?.length === 1 && productLineHasError(0) ? " ck-line--error" : ""}`}>
        <span className="ck-summary__label">
          {infoSource.laguangeElakay('label', infoSource.languageAPI).items} ({itemsCount})
        </span>
        <span className="ck-summary__value">
          {ItemsOrder().toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
        </span>
      </div>
 
      {/* Shipping — estimation automatique (spinner pendant le calcul) */}
      <div className="ck-summary__row">
        <span className="ck-summary__label">
          {infoSource.laguangeElakay('label', infoSource.languageAPI).shipping || elakayAutoText("h_shipest_shipping", "Shipping")}
        </span>
        <ShippingCostValue estimate={activeShipping} />
      </div>
 
      {/* Tax — server quote only: "Calculating…" while it runs, an explicit
          state (not charged / address required / unavailable) instead of a
          misleading $0.00 */}
      <div className={`ck-summary__row${serverQuote.status === "error" && isTaxErrorCode(serverQuote.code) ? " ck-line--error" : ""}`}>
        <span className="ck-summary__label">
          {infoSource.laguangeElakay('label', infoSource.languageAPI).tax}
        </span>
        {laodButton
          ? <TaxQuoteValue quote={serverQuote} signedIn={Boolean(token)} className="ck-summary__value" />
          : <span className="ck-summary__value"><SpinValue /></span>}
      </div>

      {prixCreatorDesign > 0 && (
        <div className="ck-summary__row">
          <span className="ck-summary__label">
            {elakayAutoText("h_f684b16986a8b5", "Ask the Seller")}
          </span>
          <span className="ck-summary__value">
            {prixCreatorDesign.toLocaleString("en-US", {
              style: "currency",
              currency: "USD"
            })}
          </span>
        </div>
      )}
 
      <div className="ck-summary__divider" />
 
      {/* Total — attend laodButton */}
      <div className="ck-summary__row ck-summary__row--total">
        <span className="ck-summary__label ck-summary__label--total">
          {infoSource.laguangeElakay('label', infoSource.languageAPI).total}
        </span>
        <span className="ck-summary__value ck-summary__value--total">
          {/* Signed in: only the server total (items + shipping + tax) is shown. */}
          {token && serverQuote.status === "error"
            ? "—"
            : laodButton && activeShipping.status !== "loading" && activeShipping.status !== "idle" && (!token || serverQuote.status === "ready")
            ? getAmountTotal().toLocaleString('en-US', { style: 'currency', currency: 'USD' })
            : <SpinValue />}
        </span>
      </div>
 
      {token && <TaxBasisNote quote={serverQuote} />}
      {/* Cart page: a product the server refused is left out of the totals above. */}
      {cartLinesRefused && (
        <p className="ck-hint ck-line--error" role="alert" data-testid="ck-refused-lines">
          {[...quoteRefused.entries()].map(([i, why]) => `${products[i]?.name || ""}: ${why || elakayAutoText("h_ckout_variant_unavailable", "This product option is no longer available.")}`).join(" · ")}
          {" "}{elakayAutoText("h_tax_refused_line_action", "Remove it from your cart, or use Check-in to pay for the other products.")}
        </p>
      )}
      {/* Note expédition : origine réelle vs adresse client, délai estimé */}
      <ShippingEstimateDetails estimate={activeShipping} addressNotSelected={usingProvisionalDestination && provisionalDestination.source === "ip"} />
      {/* Visitor without a delivery address: their approximate location from
          the browser's IP (Location Context), right under "Select a delivery
          address…" -- e.g. "Default address: Santiago de los Caballeros,
          51072, Dominican Republic (DO)". */}
      {!Saddress?.country && provisionalDestination?.source === "ip" && (
        <p className="ck-default-address" data-testid="checkout-ip-default-address">
          {elakayAutoText("h_locctx_default_address", "Default address")}: {formatIpDefaultAddress(provisionalDestination)}
        </p>
      )}
      {usingProvisionalDestination && provisionalDestination.source === "target" && (
        <p className="ck-hint" data-testid="checkout-provisional-destination">
          {elakayAutoText("h_locctx_estimate_target", "Shipping and taxes estimated for your selected location")}
          {provisionalDestination.label ? `: ${provisionalDestination.label}. ` : ". "}
          {elakayAutoText("h_locctx_estimate_final", "The final amount is calculated with your delivery address.")}
        </p>
      )}
 
    </div>
  );

  /* ── Section détail produit ── */
  const ItemDetail = () => (
    <div className="ck-card">
      <div className="ck-card__header">
        <span className="ck-card__icon">🛍️</span>
        <h3 className="ck-card__title">{infoSource.laguangeElakay('title', infoSource.languageAPI).itemDetail}</h3>
      </div>
      <OrderSummaryTable highlightErrors />
    </div>
  );

  /* ── Adresse livraison ── */
  const ShippingAddress = () => (
    <div className="ck-card">
      <div className="ck-card__header">
        <span className="ck-card__icon">📍</span>
        <h3 className="ck-card__title">{infoSource.laguangeElakay('title', infoSource.languageAPI).shippnigAddress}</h3>
        <Link to={profileAddressUrl} className="ck-card__action-link">
          {infoSource.laguangeElakay('Link', infoSource.languageAPI).changeDefaultAddress}
        </Link>
      </div>
      <ErrorAlert message={message} setMessage={setMessage} duration={30000} />
      {pendingOrderId && <>
        <Link to="/c/orders" className="ck-card__action-link">{infoSource.laguangeElakay('menuList', infoSource.languageAPI).myOrders}</Link>
        <button type="button" className="ck-btn ck-btn--secondary" onClick={() => {
          checkoutAttempt(isAuthenticated()?.user?._id || token, lastCheckoutBody.current).complete();
          setPendingOrderId(null); setData({ loading: false, redirectToFilter: false, success: false }); setMessage({ sms: null, al: 2 });
        }}>{orderText('newOrder')}</button>
      </>}
      {Saddress ? (
        <>
          <div className="ck-address-display">
            <p className="ck-address-display__name">{firstName} {lastName}</p>
            <p className="ck-address-display__line">{line1}</p>
            <p className="ck-address-display__line">{city}, {state} {postal_code}</p>
            <p className="ck-address-display__line">{country}</p>
            <p className="ck-address-display__tel">📞 {infoSource.laguangeElakay('label', infoSource.languageAPI).phone}: {tel}</p>
          </div>
          {addressFinal ? FormAddress() : SelectAddress()}
        </>
      ) : (
        <p className="ck-alert ck-alert--danger">
          {infoSource.laguangeElakay('text', infoSource.languageAPI).textCheckOutProd1}
        </p>
      )}
    </div>
  );

  const SelectAddress = () => (
    <div className="ck-form-group">
      <label className="ck-label">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCheckOutProd2}</label>
      <select onChange={selectAdress()} className="ck-select">
        <option value='0'>{infoSource.laguangeElakay('label', infoSource.languageAPI).pleaseSelect}</option>
        {addressSel?.map((Adre, i) => (
          <option key={i} value={Adre?._id}>
            ({Adre?.firstName} {Adre?.lastName}) {Adre?.Address1}, {Adre?.city} {Adre?.State} {Adre?.postalCode} {Adre?.country}
          </option>
        ))}
      </select>
      <button onClick={() => setAddressFinal(true)} type="button" className="ck-btn ck-btn--ghost ck-btn--sm">
        {infoSource.laguangeElakay('Button', infoSource.languageAPI).change}
      </button>
    </div>
  );

  const FormAddress = () => (
    <div className="ck-form-address">
      <label className="ck-label">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCheckOutProd2}</label>
      {[
        { key: 'firstName', label: infoSource.laguangeElakay('label', infoSource.languageAPI).fisrtName, placeholder: firstName, hint: elakayAutoText("h_checkoutprod_hint_firstname", "First name of the person receiving the order") },
        { key: 'lastName',  label: infoSource.laguangeElakay('label', infoSource.languageAPI).lastName,  placeholder: lastName, hint: elakayAutoText("h_checkoutprod_hint_lastname", "Last name of the person receiving the order")  },
        { key: 'line1',     label: infoSource.laguangeElakay('label', infoSource.languageAPI).Address1,  placeholder: line1, hint: elakayAutoText("h_checkoutprod_hint_address1", "Street number and name (e.g. 123 Main St)")     },
      ].map(({ key, label, placeholder, hint }) => (
        <div className="ck-form-group" key={key}>
          <label className="ck-label">{label}</label>
          <input onChange={handleChange(key)} type="text" placeholder={placeholder} className="ck-input" />
          <small className="ck-hint">{hint}</small>
        </div>
      ))}
      {/* Country / ZIP / State / City: shared address location fields; the
          shipping estimate and the tax lookup read the same Saddress. */}
      <AddressLocationSelector
        idPrefix="ck-address"
        value={toLocationValue(Saddress, STRIPE_FIELDS)}
        onChange={(location) => { setAddressTouched(true); setSAddressFinal((prev) => fromLocationValue(prev, location, STRIPE_FIELDS)); }}
        emptyCountryLabel={infoSource.laguangeElakay('label', infoSource.languageAPI).country}
        labels={{ country: infoSource.laguangeElakay('label', infoSource.languageAPI).country }}
        classNames={{ field: "ck-form-group", label: "ck-label", input: "ck-input", select: "ck-select", hint: "ck-hint" }}
        hints={{
          country: elakayAutoText("h_checkoutprod_hint_country", "The country for this shipping address"),
          postalCode: elakayAutoText("h_checkoutprod_hint_zip", "The ZIP or postal code for this shipping address"),
          state: elakayAutoText("h_checkoutprod_hint_state", "The state or province for this shipping address"),
          city: elakayAutoText("h_checkoutprod_hint_city", "The city for this shipping address"),
        }}
      />
      <div className="ck-form-actions">
        <button onClick={() => backDefault(token)} type="button" className="ck-btn ck-btn--ghost ck-btn--sm">
          {infoSource.laguangeElakay('Button', infoSource.languageAPI).cancel}
        </button>
        <button onClick={() => setAddressFinal(false)} type="button" className="ck-btn ck-btn--ghost ck-btn--sm">
          {infoSource.laguangeElakay('Button', infoSource.languageAPI).change}
        </button>
      </div>
    </div>
  );

  /* ── Paiement ── */
  const selectedCardExpired = Number(b_exp_year) < new Date().getFullYear()
    || (Number(b_exp_year) === new Date().getFullYear() && Number(b_exp_month) < new Date().getMonth() + 1);
  const hasSavedCards = Array.isArray(paymentMethods) && paymentMethods.length > 0;

  const Payment_Info = () => (
    <div>
      <div className="ck-payment-grid">
        <div className="ck-payment-grid__card">
          {b_last4 && (
            <CardsForm last4={b_last4} brand={b_brand} exp_month={b_exp_month} exp_year={b_exp_year} name={b_name} />
          )}
        </div>
        <div className="ck-payment-grid__billing">
          <h4 className="ck-section-subtitle">{infoSource.laguangeElakay('title', infoSource.languageAPI).billingAddress}</h4>
          <p className="ck-billing-line">{b_name}</p>
          <p className="ck-billing-line">{b_line1}</p>
          <p className="ck-billing-line">{b_city}</p>
          <p className="ck-billing-line"> {b_state && `${b_state}, ${b_country},  ${b_postal_code}`}</p>
        </div>
      </div>
      <div className="ck-form-group ck-form-group--mt">
        <label className="ck-label">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCheckOutProd3}</label>
        <select onChange={selectPayment()} className="ck-select" value={PM_id_sel || "0"}>
          <option value='0'>{infoSource.laguangeElakay('label', infoSource.languageAPI).pleaseSelect}</option>
          {paymentMethods?.map((Adre, i) => (
            <option key={i} value={Adre.id}>
              {Adre?.brand} {infoSource.laguangeElakay('label', infoSource.languageAPI).ending}: ...{Adre?.last4} {infoSource.laguangeElakay('label', infoSource.languageAPI).expires}: {Adre?.exp_month}/{Adre?.exp_year}
            </option>
          ))}
        </select>
        {!hasSavedCards && (
          <p className="ck-hint" role="status">{__elakayText("t054", "No saved card")}. {__elakayText("t055", "Add a card if you want to use card payment later.")}</p>
        )}
        {hasSavedCards && !PM_id_sel && (
          <p className="ck-hint" role="status">{__elakayText("t052", "No payment method selected")}. {__elakayText("t053", "Select Card")}</p>
        )}
        {PM_id_sel && selectedCardExpired && (
          <p className="ck-hint ck-line--error" role="alert">{elakayAutoText("h_pay_card_expired", "This card has expired. Select another card or add a new one.")}</p>
        )}
        <Link to={walletCardUrl} className="ck-link ck-link--right">
          {infoSource.laguangeElakay('Link', infoSource.languageAPI).addOrtherCard}
        </Link>
      </div>
    </div>
  );

  /* ── Bouton Pay ── */
  // const Payment_Button = () => (
  //   <div className="ck-pay-btn-wrap">
  //     {checkPayBtn()
  //       ? <button type="button" onClick={buttonCheckout} className="ck-btn ck-btn--primary ck-btn--block">
  //           <span className="ck-btn__icon">🔒</span>
  //           {data.loading ? orderText('processing') : infoSource.laguangeElakay('Button', infoSource.languageAPI).buyNow}
  //         </button>
  //       : <button className="ck-btn ck-btn--primary ck-btn--block ck-btn--disabled" disabled>
  //           <span className="ck-btn__icon">🔒</span>
  //           {data.loading ? orderText('processing') : infoSource.laguangeElakay('Button', infoSource.languageAPI).buyNow}
  //         </button>
  //     }
  //   </div>
  // );

/* ══════════════════════════════════════════════════════
   Payment slot — ONE dynamic area in the existing modal.
   Rendered by function call (not as an inline component) so the PayPal /
   wallet buttons are not remounted on every checkout re-render.
══════════════════════════════════════════════════════ */
const renderAlternativePayment = () => {
  const reason = getPaymentButtonReason({ skipCardChecks: true });
  if (reason) {
    return (
      <div className="elk-notice elk-notice--warn" role="status">
        <div>{reason.reason}</div>
        {reason.action && <div style={{ opacity: 0.85 }}>{reason.action}</div>}
      </div>
    );
  }
  if (selectedPaymentMethod === "paypal") {
    return (
      <PayPalCheckoutButton
        clientId={paypalClientId}
        createElakayOrder={createPayPalElakayOrder}
        approve={approvePayPalOrder}
        cancel={cancelPayPalOrder}
        onError={() => {
          // Elakay's own errors were already shown by createPaymentIntent.
          if (!error) setMessage({ sms: elakayAutoText("h_pay_generic_error", "Something went wrong. Please try again."), al: 1 });
        }}
      />
    );
  }
  return (
    <WalletPayButton
      key={selectedPaymentMethod}
      wallet={selectedPaymentMethod}
      amountCents={Math.round((Number(getAmountTotal()) || 0) * 100)}
      onPaymentMethod={(paymentMethodId) => payWithWallet(selectedPaymentMethod, paymentMethodId)}
    />
  );
};

const renderPaymentSlot = () => {
  return (
    <div className="ck-card elk-pay-slot">
      <div className="ck-card__header">
        <span className="ck-card__icon">💳</span>
        <h3 className="ck-card__title">{infoSource.laguangeElakay('title', infoSource.languageAPI).paymentInfo}</h3>
      </div>
      {checkoutMethods.length ? (
        <CheckoutPaymentMethods methods={checkoutMethods} selected={selectedPaymentMethod} onSelect={setPaymentChoice}>
          {selectedPaymentMethod === "stripe" ? Payment_Info() : renderAlternativePayment()}
        </CheckoutPaymentMethods>
      ) : (
        <div className="elk-notice elk-notice--warn" role="status">
          {methodAvailability.status === "error"
            ? elakayAutoText("h_pay_technical_error", "A technical error prevents payment right now.")
            : elakayAutoText("h_pay_no_method", "No Payment Method Available")}
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════════════════════
   getPaymentButtonReason — retourne le texte expliquant
   pourquoi le bouton est désactivé, ou null si actif
══════════════════════════════════════════════════════ */
// `skipCardChecks`: PayPal / Apple Pay / Google Pay do not use a saved card,
// every other validation (address, shipping, lines, totals) still applies.
const getPaymentButtonReason = ({ skipCardChecks = true } = {}) => {
  if (pendingOrderId) return { reason: orderText('created'), type: "info" };
  if (data.loading) return { reason: elakayAutoText("h_checkout_authorizing", "Submitting your order…"), type: "info" };
  if (methodAvailability.status === "loading") return { reason: elakayAutoText("h_pay_loading", "Loading..."), type: "info" };
  if (methodAvailability.status === "error") return {
    reason: elakayAutoText("h_pay_technical_error", "A technical error prevents payment right now."),
    action: elakayAutoText("h_pay_retry", "Retry"), type: "error",
  };
  if (!checkoutMethods.length || !selectedPaymentMethod) return {
    reason: elakayAutoText("h_pay_no_method", "No Payment Method Available"),
    action: elakayAutoText("h_pay_choose_method", "Choose Payment Method"), type: "error",
  };
  if (selectedPaymentMethod === "stripe" && savedCardsState.status === "loading") return { reason: elakayAutoText("h_pay_loading", "Loading..."), type: "info" };
  if (selectedPaymentMethod === "stripe" && savedCardsState.status === "error") return {
    reason: elakayAutoText("h_pay_technical_error", "A technical error prevents payment right now."),
    action: elakayAutoText("h_pay_retry", "Retry"), type: "error",
  };
  if (selectedPaymentMethod === "stripe" && selectedCardExpired) return {
    reason: elakayAutoText("h_pay_card_expired", "This card has expired. Select another card or add a new one."),
    action: elakayAutoText("h_pay_select_card", "Select Card"), type: "warn",
  };
  const orderData = createOrderDataNew || {};
  const productsList = Array.isArray(orderData.products)
    ? orderData.products
    : [];

  const isEmpty = (value) =>
    value === undefined ||
    value === null ||
    value === "" ||
    (typeof value === "string" && value.trim() === "");

  const isEmptyObject = (obj) =>
    !obj || typeof obj !== "object" || Object.keys(obj).length === 0;

  const hasInvalidValue = (obj) =>
    Object.values(obj || {}).some(
      (value) => value === null || value === undefined || value === ""
    );

  if (prixCreatorDesign > 0) return { reason: elakayAutoText("h_pay_design_quote_required", "The design fee needs a confirmed server quote before payment."), type: "error" };
  if (cartLinesRefused) {
    const names = [...quoteRefused.keys()].map((i) => products[i]?.name).filter(Boolean).join(", ");
    return {
      reason: `${names}: ${[...quoteRefused.values()][0] || elakayAutoText("h_ckout_variant_unavailable", "This product option is no longer available.")}`,
      action: elakayAutoText("h_tax_refused_line_action", "Remove it from your cart, or use Check-in to pay for the other products."),
      type: "error",
    };
  }
  if (serverQuote.status !== "ready") return { reason: serverQuote.error || elakayAutoText("h_pay_quote_wait", "Waiting for the server checkout total."), type: "info" };

  if (productsList.length === 0) {
    return {
      reason: __elakayText("t012", "No products in order"),
      action: __elakayText("t013", "Add at least one product before continuing to payment."),
      type: "error",
    };
  }

  if (activeShipping.status === "loading" || activeShipping.status === "idle") {
    return {
      reason: elakayAutoText("h_shipest_wait_reason", "Calculating shipping"),
      action: elakayAutoText("h_shipest_wait_action", "Please wait while the shipping cost is calculated."),
      type: "info",
    };
  }

  // The estimate failed: the quote still shows the tax (activeShippingSettled),
  // but nothing is paid before the buyer has seen the shipping amount.
  if (activeShipping.status === "error") {
    return {
      reason: __elakayText("t016", "Shipping amount is invalid"),
      action: __elakayText("t017", "Calculate the shipping cost before continuing."),
      type: "warn",
    };
  }

  // CJ product the Seller does not sell to this country (destination
  // disabled or not configured): the server refuses the order anyway
  // (DESTINATION_NOT_AVAILABLE) -- say it before payment.
  // Same for a lane whose real rate could not be calculated (supplier API
  // down, no route): refused server-side (SHIPPING_RATE_UNAVAILABLE), never
  // charged with an old/other-destination rate.
  const blockedLine = (activeShipping.data?.lines || []).find((l) => SHIPPING_BLOCKING_SOURCES.has(l.cost?.source));
  if (activeShipping.status === "ready" && blockedLine) {
    return {
      reason: RATE_BLOCKING_SOURCES.has(blockedLine.cost?.source)
        ? elakayAutoText("h_salesim_rate_unavailable_short", "Shipping unavailable")
        : elakayAutoText("h_shipest_destination_blocked_reason", "Not available for this destination"),
      action: blockedLineMessage(blockedLine, activeShipping.data?.destination?.country),
      type: "error",
    };
  }

  if (isEmpty(orderData.amountTotal) || Number(orderData.amountTotal) <= 0) {
    return {
      reason: __elakayText("t014", "Invalid order total amount"),
      action: __elakayText("t015", "Refresh the cart or recalculate the order total before payment."),
      type: "error",
    };
  }

  if (
    orderData.shipping_amount_local == null ||
    Number.isNaN(Number(orderData.shipping_amount_local))
  ) {
    return {
      reason: __elakayText("t016", "Shipping amount is invalid"),
      action: __elakayText("t017", "Calculate the shipping cost before continuing."),
      type: "warn",
    };
  }

  if (!orderData.Delivered) {
    return {
      reason: __elakayText("t018", "Delivery date is missing"),
      action: __elakayText("t019", "Select or calculate a delivery date."),
      type: "warn",
    };
  }

  const address = orderData.shippingAddress || {};

  const missingAddressFields = [
    ["firstName", __elakayText("t022", "first name")],
    ["lastName", __elakayText("t023", "last name")],
    ["tel", __elakayText("t024", "phone number")],
    ["city", __elakayText("t025", "city")],
    ["country", __elakayText("t026", "country")],
    ["line1", __elakayText("t027", "street address")],
    ["postal_code", __elakayText("t028", "postal code")],
    ["state", __elakayText("t029", "state")],
  ].filter(([key]) => isEmpty(address[key]));

  if (missingAddressFields.length > 0) {
    return {
      reason: __elakayText("t020", "Complete your shipping address"),
      action: `${__elakayText("t021", "Please add:")} ${missingAddressFields
        .map(([, label]) => label)
        .join(", ")}.`,
      type: "warn",
    };
  }

  for (const product of productsList) {
    const productIssue = getProductLineIssue(product);
    if (productIssue) return productIssue;

    if (!product.paymentIntent) {
      return {
        reason: __elakayText("t048", "Payment information is missing"),
        action: __elakayText("t049", "Initialize the payment information before continuing."),
        type: "error",
      };
    }

    if (!skipCardChecks && isEmpty(product.paymentIntent.customer)) {
      return {
        reason: __elakayText("t050", "Stripe customer is missing"),
        action: __elakayText("t051", "Create or load the Stripe customer before continuing."),
        type: "error",
      };
    }

    if (!skipCardChecks && isEmpty(product.paymentIntent.payment_method)) {
      return {
        reason: __elakayText("t052", "No payment method selected"),
        action: __elakayText("t053", "Select or add a payment method before continuing."),
        type: "warn",
      };
    }
  }

  const hasPaymentMethodFromSPM =
    !isEmptyObject(SPM) && !hasInvalidValue(SPM);

  if (!skipCardChecks && !hasPaymentMethodFromSPM) {
    return {
      reason: __elakayText("t054", "Select a payment method"),
      action: __elakayText("t055", "Choose an existing card or add a new payment method."),
      type: "warn",
    };
  }

  const hasGraphicProduct = productsList.some((product) => product.graphic);

  if (hasGraphicProduct) {
    if (!graphicSubmitted || !graphicOrderInfo) {
      return {
        reason: __elakayText("t056", "Customize your design"),
        action: __elakayText("t057", "Complete Step 1 and submit your graphic design information."),
        type: "warn",
      };
    }

    const sourceType = graphicOrderInfo.sourceType;

    if (!sourceType) {
      return {
        reason: __elakayText("t058", "Graphic type is missing"),
        action: __elakayText("t059", "Choose Custom Design, Ask Seller, or Template."),
        type: "warn",
      };
    }

    if (sourceType === "custom") {
      const slots = graphicOrderInfo.slots || [];

      if (slots.length === 0) {
        return {
          reason: __elakayText("t060", "No design face configured"),
          action: __elakayText("t061", "Configure at least one face of the product design."),
          type: "warn",
        };
      }

      const hasAnyData = slots.some((slot) => {
        const hasBg =
          slot.url &&
          !slot.url.startsWith("blob:") &&
          !slot.url.startsWith("data:");

        const hasText = (slot.slotState?.texts || []).some(
          (text) => text?.content?.trim().length > 0
        );

        const hasLayer = (slot.slotState?.layers || []).some((layer) => {
          const url = layer?.urlImg || layer?.src || layer?.url || "";

          const hasValidUrl =
            url &&
            !url.startsWith("blob:") &&
            !url.startsWith("data:");

          const hasNewFile =
            !!layer?.hasNewFile ||
            (typeof File !== "undefined" && layer?.file instanceof File);

          return hasValidUrl || hasNewFile;
        });

        return hasBg || hasText || hasLayer;
      });

      if (!hasAnyData) {
        return {
          reason: __elakayText("t062", "Design is empty"),
          action: __elakayText("t063", "Add text, image, layer, or background to your design."),
          type: "warn",
        };
      }
    }

    if (sourceType === "ask") {
      const ask = graphicOrderInfo.askSellerData || {};
      const emptyText = (value) =>
        !value || typeof value !== "string" || value.trim().length === 0;

      const hasAnyData =
        !emptyText(ask.specialInstructions) ||
        !emptyText(ask.artistMessage) ||
        !emptyText(ask.avoidInstructions) ||
        !emptyText(ask.requiredInstructions) ||
        !emptyText(ask.detailLevel) ||
        !emptyText(ask.budget) ||
        ask.desiredDate ||
        ask.stylePrefs?.length > 0 ||
        ask.inspirations?.length > 0 ||
        ask.refs?.some((ref) => ref);

      if (!hasAnyData) {
        return {
          reason: __elakayText("t064", "Graphic request is empty"),
          action: __elakayText(
            "t065",
            "Fill at least one field: instructions, message, style, budget, date, inspiration, or reference image."
          ),
          type: "warn",
        };
      }
    }

    if (sourceType === "template") {
      if (!graphicOrderInfo.templateRef) {
        return {
          reason: __elakayText("t066", "No template selected"),
          action: __elakayText("t067", "Select one template before continuing to payment."),
          type: "warn",
        };
      }

      const isValidTemplate =
        typeof graphicOrderInfo.templateRef === "string" &&
        /^[a-f0-9]{24}$/i.test(graphicOrderInfo.templateRef);

      if (!isValidTemplate) {
        return {
          reason: __elakayText("t068", "Invalid template selected"),
          action: __elakayText("t069", "Select a valid template or refresh the page and try again."),
          type: "error",
        };
      }
    }
  }

  return null;
};

/* ══════════════════════════════════════════════════════
   Payment_Button — bouton de paiement avec feedback
══════════════════════════════════════════════════════ */
const Payment_Button = () => {
  const immediatePayment = Boolean(selectedPaymentMethod && selectedPaymentMethod !== "stripe");
  // PayPal and device wallets own their authorized provider buttons inside
  // the payment slot. Never expose a second generic button that could create
  // the order without completing the provider approval flow.
  if (immediatePayment) return null;
  const buttonReason = getPaymentButtonReason({ skipCardChecks: selectedPaymentMethod !== "stripe" });
  return (
    <div className="ck-pay-btn-wrap">
      {!buttonReason ? (
        <button 
          type="button" 
          onClick={buttonCheckout}
          disabled={data.loading || Boolean(pendingOrderId)}
          aria-busy={data.loading}
          className="ck-btn ck-btn--primary ck-btn--block">
          <span className="ck-btn__icon">🔒</span>
          {data.loading ? orderText('processing') : immediatePayment
            ? checkoutMethodActionLabel(selectedPaymentMethod)
            : elakayAutoText("h_checkout_place_order", "Place Order")}
        </button>
      ) : (
        <>
          <button 
            type="button"
            className="ck-btn ck-btn--primary ck-btn--block ck-btn--disabled" 
            disabled>
            <span className="ck-btn__icon">🔒</span>
            {data.loading ? orderText('processing') : immediatePayment
              ? checkoutMethodActionLabel(selectedPaymentMethod)
              : elakayAutoText("h_checkout_place_order", "Place Order")}
          </button>

          {/* 🆕 Feedback visible expliquant pourquoi le bouton est désactivé */}
          <div style={{
  marginTop: 10,
  padding: "12px 14px",
  borderRadius: 12,
  border: `1px solid ${
    buttonReason.type === "error"
      ? "#fca5a5"
      : buttonReason.type === "warn"
      ? "#fcd34d"
      : buttonReason.type === "success"
      ? "#86efac"
      : "#93c5fd"
  }`,
  background:
    buttonReason.type === "error"
      ? "#fef2f2"
      : buttonReason.type === "warn"
      ? "#fffbeb"
      : buttonReason.type === "success"
      ? "#f0fdf4"
      : "#eff6ff",
  color:
    buttonReason.type === "error"
      ? "#b91c1c"
      : buttonReason.type === "warn"
      ? "#b45309"
      : buttonReason.type === "success"
      ? "#166534"
      : "#1d4ed8",
  fontSize: 13,
  fontWeight: 500,
  display: "flex",
  alignItems: "flex-start",
  gap: 10,
  lineHeight: 1.6,
  boxShadow: "0 2px 8px rgba(0,0,0,.05)",
  transition: "all .25s ease",
  wordBreak: "break-word",
}}>
            <span style={{ fontSize: 14 }}>
              {buttonReason.type === "error" ? "⚠️" : "ℹ️"}
            </span>
            <span style={{ flex: 1 }}>
              <div style={{ fontWeight: 500 }}>{buttonReason.reason}</div>
              {buttonReason.action && (
                <div style={{ fontWeight: 400, marginTop: 2, opacity: 0.85 }}>
                  {buttonReason.action}
                </div>
              )}
            </span>
          </div>
        </>
      )}
      {!immediatePayment && (
        <p className="ck-hint" style={{ marginTop: 8 }}>
          {elakayAutoText("h_checkout_order_before_payment", "This creates a pending order. You are not charged now; payment is confirmed separately from My Orders.")}
        </p>
      )}
    </div>
  );
};
  /* ── Section graphic ── */
  const hrefAndLink = () => (
    <div className="ck-radio-group">
      {products[0].graphic && (
        <label className="ck-radio-option">
          <input type="radio" name="href_link" onChange={() => btnCustomShooseen('UD')} checked={designRequest === 'UD'} />
          <span className="ck-radio-custom" />
          <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).checkoutProd.t001}</span>
        </label>
      )}
      {products[0].creatorDesign && (
        <label className="ck-radio-option">
          <input type="radio" name="href_link" onChange={() => btnCustomShooseen("CD")} checked={designRequest === 'CD'} />
          <span className="ck-radio-custom" />
          <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).checkoutProd.t002}</span>
        </label>
      )}
      {products[0].graphic && (
        <label className="ck-radio-option">
          <input type="radio" name="href_link" onChange={() => btnCustomShooseen("ED")} checked={designRequest === "ED"} />
          <span className="ck-radio-custom" />
          <span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).checkoutProd.t003}</span>
        </label>
      )}
    </div>
  );

  const formGraphicNote = (rows = 10, ml = 1000) => (
    <div className="ck-form-group">
      <label className="ck-label">{infoSource.laguangeElakay('title', infoSource.languageAPI).noteOder}</label>
      <textarea
        onChange={e => setGraphicNote(e.target.value)}
        className="ck-textarea"
        value={graphicNote}
        rows={rows}
        maxLength={ml}
      />
      {products[0].creatorDesign
        ? <ErrorAlert message={{ sms: infoSource.laguangeElakay('text', infoSource.languageAPI).textGraphicnote0, al: 1 }} setMessage={setMessage} duration={null} />
        : <ErrorAlert message={{ sms: infoSource.laguangeElakay('text', infoSource.languageAPI).textGraphicnote1, al: 0 }} setMessage={setMessage} duration={null} />
      }
    </div>
  );

  const formGraphicDesign = () => (
    <div className="ck-form-group">
      <h3 className="ck-section-subtitle">{infoSource.language(infoSource, "label", "AddGraphicNote")}</h3>
      <ImagesLoadingOrderGraphic infoSource={infoSource} post={post} setPost={setPost} setError={setError} />
      <ErrorAlert message={{ sms: infoSource.laguangeElakay('text', infoSource.languageAPI).textGraphicDesign, al: 1 }} setMessage={setMessage} duration={null} />
    </div>
  );

  /* ── Stepper graphic ── */
  const stepPageGraphic = () => (
    <div className="ck-stepper">
      <div
        className={`ck-stepper__step ${!nextPage ? 'ck-stepper__step--active' : ''}`}
        onClick={() => { setNextPage(false); validateOrder(); }}
      >
        <span className="ck-stepper__num">01</span>
        <span className="ck-stepper__label">{infoSource.language(infoSource, "sellPage", "graphicDesign")}</span>
      </div>
      <div className="ck-stepper__line" />
      <div
        className={`ck-stepper__step ${nextPage ? 'ck-stepper__step--active' : ''}`}
        onClick={() => validateOrder() && setNextPage(true)}
      >
        <span className="ck-stepper__num">02</span>
        <span className="ck-stepper__label">{infoSource.laguangeElakay('title', infoSource.languageAPI).checkout}</span>
      </div>
    </div>
  );



const allPageGraphic_Payment = () => {

  if (products[0].graphic) {
    return (
      <>
        {/* ── ÉTAPE 1 : Configurator ── */}
        {!graphicSubmitted && (
          <GraffitiConfigurator
            productID={products[0]?.productID}
            authToken={token}
            infoSource={infoSource}
            sellerSlots={products[0]?.sellerSlots || []}
            ImagesProd={galeries || []}
            product={products[0]}
            initialGraphicInfo={graphicOrderInfo}
            apiUrl={null}                       /* 🆕 Pas de backend ici */
            amountTotal={getAmountTotal()}
            setPrixCreatorDesign={setPrixCreatorDesign}
            onAddToCart={handleAddToCartFromGraffiti}
          />
        )}

        {/* ── ÉTAPE 2 : Checkout standard ── */}
        {graphicSubmitted && (
          <>
            {/* 🆕 Banner avec Edit + Preview */}
            <div style={{
              display: "flex", alignItems: "center", gap: 12,
              padding: "14px 16px", marginBottom: 18,
              background: "linear-gradient(135deg, rgba(52,199,89,.08), rgba(52,199,89,.03))",
              border: "1px solid rgba(52,199,89,.25)",
              borderRadius: "var(--ck-radius)",
              flexWrap: "wrap"
            }}>
              <span style={{ fontSize: 26, flexShrink: 0 }}>✅</span>

              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{ 
                  fontSize: 13, 
                  fontWeight: 700, 
                  color: "#34c759",
                  marginBottom: 3 
                }}>{__elakayText("t005", "Step 1 complete — Design customized")}</div>
                <div style={{ fontSize: 10.5, color: "#5a7a8a" }}>{__elakayText("t006", "Mode:")}<strong style={{ textTransform: "capitalize" }}>
                    {graphicOrderInfo?.sourceType === "custom" && elakayAutoText("h_95ada4acac6af0", "Submit Your Design")}
                    {graphicOrderInfo?.sourceType === "ask" && elakayAutoText("h_f684b16986a8b5", "Ask the Seller")}
                    {graphicOrderInfo?.sourceType === "template" && elakayAutoText("h_dbdc3061b40211", "Use Existing Graphic")}
                  </strong>
                  {graphicOrderInfo?.templateRef && (
                    <>{__elakayText("t007", "· Template:")}{graphicOrderInfo?.templateMeta?.label || elakayAutoText("h_9a976fc228b6b3", "Selected")}</>
                  )}
                  {graphicOrderInfo?.slots?.length > 0 && (
                    <> · {graphicOrderInfo.slots.length}{__elakayText("t008", "face(s)")}</>
                  )}
                </div>
              </div>

              {/* 🆕 Groupe de boutons Edit + Preview */}
              <div style={{ 
                display: "flex", 
                gap: 6, 
                flexShrink: 0,
                flexWrap: "wrap"
              }}>
                <button
                  className="ck-btn ck-btn--ghost ck-btn--sm"
                  onClick={() => setShowGraphicPreview(true)}>{__elakayText("t009", "👁 Preview")}</button>
                <button
                  className="ck-btn ck-btn--ghost ck-btn--sm"
                  onClick={() => setGraphicSubmitted(false)}>{__elakayText("t010", "← Edit design")}</button>
              </div>
            </div>

            {/* Step 2 : Checkout standard */}
            {checkIfObjectIsEmpty(addressShop) && <Payment_Button />}
            <ItemDetail />
            <ShippingAddress />
            {renderPaymentSlot()}
            {checkIfObjectIsEmpty(addressShop) && <Payment_Button />}
          </>
        )}

        {/* 🆕 Modal de preview du graphic */}
        {showGraphicPreview && graphicOrderInfo && (
          <GraphicPreviewModal
            graphicInfo={graphicOrderInfo}
            product={products[0]}
            infoSource={infoSource}
            onClose={() => setShowGraphicPreview(false)}
            onEdit={() => {
              setShowGraphicPreview(false);
              setGraphicSubmitted(false);
            }}
          />
        )}
      </>
    );
  }

  /* Flow non-graphic inchangé */
  return (
    <>
      {checkIfObjectIsEmpty(addressShop) && <Payment_Button />}
      <ItemDetail />
      <ShippingAddress />
      {renderPaymentSlot()}
      {checkIfObjectIsEmpty(addressShop) && <Payment_Button />}
    </>
  );
};

  /* ── BSbutton (bouton d'entrée) ── */
  const BSbutton = () => {
    if (!isAuthenticated()) {
      return (
        <Link to={signInUrl}>
          <button className="ck-btn ck-btn--primary ck-btn--block">
            {infoSource.laguangeElakay('Button', infoSource.languageAPI).signinTocheck}
          </button>
        </Link>
      );
    }
    if (!Saddress?.country) {
      return (
        <Link to={profileAddressUrl} className="ck-btn ck-btn--primary ck-btn--block">
          {infoSource.laguangeElakay('Button', infoSource.languageAPI).addAdress}
        </Link>
      );
    }
    const walletCheckPending = methodAvailability.status === "loading"
      || (allowedMethods.paypal && !paypalChecked)
      || ((allowedMethods.googlePay || allowedMethods.applePay) && !walletAvailability.checked);
    if (walletCheckPending || savedCardsState.status === "loading") {
      return <div className="ck-loading-btn"><span>⟳</span>{elakayAutoText("h_pay_loading", "Loading...")}</div>;
    }
    const stripeReady = allowedMethods.stripe === true;
    const cardNeedsSelection = hasSavedCards && (!PM_id_sel || selectedCardExpired);
    const entryAction = resolveCheckoutEntryAction({
      loading: walletCheckPending,
      providerError: methodAvailability.status === "error",
      methods: checkoutMethods,
      stripeReady,
      cardsReady: savedCardsState.status === "ready" || !stripeReady,
      hasCards: hasSavedCards,
      selectedCardUsable: Boolean(PM_id_sel) && !selectedCardExpired,
    });

    // Restore the original full-width Add a Card action when card is the
    // fallback and there is no usable wallet. Pending order creation remains
    // available separately and never auto-charges a newly added card.
    if (entryAction === "add_card") {
      return (
        <Link to={walletCardUrl} className="ck-btn ck-btn--primary ck-btn--block">
          {infoSource.laguangeElakay('Button', infoSource.languageAPI).addCard}
        </Link>
      );
    }
    if (entryAction === "select_card" && cardNeedsSelection) {
      return (
        <button type="button" onClick={() => bntAllFontPayment("stripe")} className="ck-btn ck-btn--primary ck-btn--block">
          {elakayAutoText("h_pay_select_card", "Select Card")}
        </button>
      );
    }
    if (entryAction === "technical_error" || entryAction === "payment_unavailable") {
      return (
        <div className="elk-notice elk-notice--warn" role="status">
          {methodAvailability.status === "error"
            ? elakayAutoText("h_pay_technical_error", "A technical error prevents payment right now.")
            : elakayAutoText("h_pay_no_method", "No Payment Method Available")}
        </div>
      );
    }
    return products?.length > 0 && checkIfObjectIsEmpty(addressShop) && CheckActiveBtn() && (
      <button type="button" disabled={data.loading || Boolean(pendingOrderId)} onClick={bntAllFontPayment} className="ck-btn ck-btn--primary ck-btn--block">
        <span className="ck-btn__icon">🔒</span>
        {data.loading ? orderText('processing') : infoSource.laguangeElakay('Button', infoSource.languageAPI).buyNow}
      </button>
    );
  };

  
  /* ══════════════ STYLES ══════════════ */
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap');

    .ck-root {
      /* ── Palette Elakay ── */
      --elakay-primary:        #007399;
      --elakay-primary-dark:   #004b63;
      --elakay-primary-light:  #00a4d8;
      --elakay-accent:         #4facfe;
      --elakay-accent-light:   #00f2fe;
      --elakay-danger:         #ef4444;
      --elakay-success:        #34c759;
      --elakay-purple:         #667eea;
      --elakay-pink:           #f5576c;
      --bg-gradient-start:     #ffffff;
      --bg-gradient-end:       #f2f6fd;
      --transition-smooth:     cubic-bezier(0.4, 0, 0.2, 1);
      --transition-bounce:     cubic-bezier(0.68, -0.55, 0.265, 1.55);

      /* ── Tokens UI ── */
      --ck-bg:         linear-gradient(160deg, var(--bg-gradient-start) 0%, var(--bg-gradient-end) 100%);
      --ck-bg-card:    #ffffff;
      --ck-bg-card2:   #f4f8fc;
      --ck-border:     #daeaf5;
      --ck-border-focus: var(--elakay-primary-light);
      --ck-text:       #0d2d3d;
      --ck-text-muted: #5a7a8a;
      --ck-radius:     14px;
      --ck-radius-sm:  9px;
      --ck-shadow:     0 8px 32px rgba(0,115,153,0.10);
      --ck-shadow-sm:  0 2px 12px rgba(0,115,153,0.07);
      --ck-shadow-hover: 0 10px 36px rgba(0,115,153,0.15);

      font-family: 'Plus Jakarta Sans', sans-serif;
      color: var(--ck-text);
      background: var(--ck-bg);
      border-radius: 18px;
      padding: 1.25rem;
    }

    /* ── Summary ── */
    .ck-summary { padding: 0.25rem 0; }
    .ck-summary__row { display: flex; justify-content: space-between; align-items: center; padding: 0.6rem 0; }
    .ck-summary__label { font-size: 0.87rem; color: var(--ck-text-muted); font-weight: 400; }
    .ck-summary__value { font-size: 0.9rem; font-weight: 600; color: var(--ck-text); }
    .ck-summary__value--free { color: var(--elakay-success); }
    /* A product with an error: very pale red (10%) */
    .ck-root .ck-line--error { background: rgba(239, 68, 68, 0.10) !important; border-radius: 8px; padding-left: 0.6rem !important; padding-right: 0.6rem !important; }
    /* Line selection in the checkout modal. The native checkbox is made
       visible AND clickable again (mdbreact's global mdb.css sets every
       [type=checkbox] to position:absolute; pointer-events:none; opacity:0). */
    .ck-root .ck-line-check,
    .ck-root .ck-line-check[type="checkbox"]:checked,
    .ck-root .ck-line-check[type="checkbox"]:not(:checked) {
      position: static !important; pointer-events: auto !important; opacity: 1 !important;
      display: inline-block !important; width: 17px !important; height: 17px !important;
      margin: 0.15rem 0 0 !important; flex-shrink: 0; accent-color: var(--elakay-primary); cursor: pointer;
    }
    .ck-root .ck-line-check:disabled { cursor: not-allowed; opacity: 0.45 !important; }
    .ck-root .ck-line--excluded > span { opacity: 0.5; }
    .ck-root .ck-line--excluded > span:last-child { text-decoration: line-through; }
    .ck-line-reason { display: block; margin-top: 0.2rem; font-size: 0.78rem; font-weight: 600; color: #b42318; }
    .ck-lines-notice { margin: 0 0 0.5rem; padding: 0.5rem 0.7rem; border-radius: 9px; font-size: 0.8rem; font-weight: 500; background: #fffbeb; border: 1px solid #fcd34d; color: #b45309; }
    .ck-summary__divider { height: 1px; background: var(--ck-border); margin: 0.5rem 0; }
    .ck-summary__row--total { margin-top: 0.25rem; }
    .ck-summary__label--total { font-size: 1rem; font-weight: 700; color: var(--ck-text); }
    .ck-summary__value--total {
      font-size: 1.25rem; font-weight: 700;
      background: linear-gradient(135deg, var(--elakay-primary) 0%, var(--elakay-accent) 100%);
      -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
    }
    .ck-summary__shipping-note { margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid var(--ck-border); font-size: 0.8rem; color: var(--ck-text-muted); line-height: 1.6; }
    .ck-note { font-weight: 600; }
    .ck-note--warn { color: var(--elakay-pink); }
    .ck-note--info { color: var(--elakay-primary); }

    /* ── Cards ── */
    .ck-card {
      background: var(--ck-bg-card);
      border: 1.5px solid var(--ck-border);
      border-radius: var(--ck-radius);
      padding: 1.35rem 1.5rem;
      margin-bottom: 1rem;
      box-shadow: var(--ck-shadow-sm);
      transition: box-shadow 0.25s var(--transition-smooth), border-color 0.25s var(--transition-smooth), transform 0.25s var(--transition-smooth);
    }
    .ck-card:hover {
      border-color: var(--elakay-primary-light);
      box-shadow: var(--ck-shadow-hover);
      transform: translateY(-1px);
    }
    .ck-card__header { display: flex; align-items: center; gap: 0.65rem; margin-bottom: 1.1rem; }
    .ck-card__icon { font-size: 1.1rem; }
    .ck-card__title {
      font-size: 1rem; font-weight: 700; color: var(--elakay-primary-dark);
      margin: 0; flex: 1; letter-spacing: -0.01em;
      max-width: 100%; overflow-wrap: anywhere;
    }
    .ck-card__action-link { font-size: 0.78rem; color: var(--elakay-accent); text-decoration: none; white-space: nowrap; font-weight: 500; transition: color 0.15s var(--transition-smooth); }
    .ck-card__action-link:hover { color: var(--elakay-primary); }

    /* ── Address display ── */
    .ck-address-display {
      background: var(--ck-bg-card2);
      border-radius: var(--ck-radius-sm);
      padding: 1rem 1.1rem;
      margin-bottom: 1rem;
      border: 1px solid var(--ck-border);
      border-left: 3px solid var(--elakay-primary-light);
    }
    .ck-address-display p { margin: 0.2rem 0; font-size: 0.875rem; color: var(--ck-text); }
    .ck-address-display__name { font-weight: 700; font-size: 0.95rem !important; color: var(--elakay-primary-dark) !important; }
    .ck-address-display__tel { color: var(--ck-text-muted) !important; margin-top: 0.45rem !important; font-size: 0.82rem !important; }

    /* ── Payment grid ── */
    .ck-payment-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem; margin-bottom: 1rem; }
    @media (max-width: 640px) { .ck-payment-grid { grid-template-columns: 1fr; } }
    .ck-section-subtitle { font-size: 0.85rem; font-weight: 700; color: var(--elakay-primary-dark); margin-bottom: 0.6rem; text-transform: uppercase; letter-spacing: 0.04em; }
    .ck-billing-line { font-size: 0.85rem; color: var(--ck-text); margin: 0.18rem 0; }

    /* ── Forms ── */
    .ck-form-group { margin-bottom: 0.9rem; }
    .ck-form-group--mt { margin-top: 1rem; }
    .ck-label {
      display: block; font-size: 0.75rem; font-weight: 700;
      color: var(--ck-text-muted); text-transform: uppercase;
      letter-spacing: 0.08em; margin-bottom: 0.4rem;
    }
    .ck-input, .ck-select, .ck-textarea {
      width: 100%; background: var(--ck-bg-card2); border: 1.5px solid var(--ck-border);
      border-radius: var(--ck-radius-sm); padding: 0.65rem 0.9rem; font-size: 0.875rem;
      color: var(--ck-text); font-family: 'Plus Jakarta Sans', sans-serif;
      transition: border-color 0.2s var(--transition-smooth), box-shadow 0.2s var(--transition-smooth);
      outline: none; box-sizing: border-box;
    }
    .ck-input:focus, .ck-select:focus, .ck-textarea:focus {
      border-color: var(--elakay-primary);
      box-shadow: 0 0 0 3px rgba(0,115,153,0.12);
      background: #fff;
    }
    .ck-input:hover:not(:focus), .ck-select:hover:not(:focus), .ck-textarea:hover:not(:focus) {
      border-color: var(--elakay-primary-light);
    }
    .ck-select {
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' fill='none'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23007399' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
      background-repeat: no-repeat; background-position: right 0.9rem center; padding-right: 2.2rem;
    }
    .ck-textarea { resize: vertical; min-height: 100px; }
    .ck-form-actions { display: flex; gap: 0.75rem; margin-top: 0.75rem; }
    .ck-form-address { padding: 0.5rem 0; }
    .ck-link { font-size: 0.82rem; color: var(--elakay-primary); text-decoration: none; font-weight: 500; transition: color 0.15s; }
    .ck-link--right { display: block; text-align: right; margin-top: 0.5rem; }
    .ck-link:hover { color: var(--elakay-accent); }

    /* ── Buttons ── */
    .ck-btn {
      display: inline-flex; align-items: center; justify-content: center; gap: 0.45rem;
      padding: 0.72rem 1.5rem; border-radius: var(--ck-radius-sm); font-size: 0.875rem;
      font-weight: 700; font-family: 'Plus Jakarta Sans', sans-serif; cursor: pointer;
      transition: all 0.2s var(--transition-smooth); border: none; text-decoration: none;
      letter-spacing: 0.01em;
    }
    .ck-btn--primary {
      background: linear-gradient(135deg, var(--elakay-primary) 0%, var(--elakay-primary-dark) 100%);
      color: #fff;
      box-shadow: 0 4px 18px rgba(0,115,153,0.28);
    }
    .ck-btn--primary:hover:not(.ck-btn--disabled) {
      background: linear-gradient(135deg, var(--elakay-primary-light) 0%, var(--elakay-primary) 100%);
      transform: translateY(-2px);
      box-shadow: 0 8px 28px rgba(0,115,153,0.38);
    }
    .ck-btn--primary:active:not(.ck-btn--disabled) { transform: translateY(0); }
    .ck-btn--secondary {
      background: var(--ck-bg-card2); color: var(--elakay-primary);
      border: 1.5px solid var(--ck-border); font-weight: 600;
    }
    .ck-btn--secondary:hover:not(.ck-btn--disabled) {
      border-color: var(--elakay-primary); background: rgba(0,115,153,0.06);
      transform: translateY(-1px);
    }
    .ck-btn--ghost {
      background: transparent; color: var(--elakay-primary);
      border: 1.5px solid var(--elakay-primary-light);
    }
    .ck-btn--ghost:hover { background: rgba(0,115,153,0.07); border-color: var(--elakay-primary); }
    .ck-btn--block { width: 100%; }
    .ck-btn--sm { padding: 0.42rem 1rem; font-size: 0.8rem; }
    .ck-btn--disabled { opacity: 0.38; cursor: not-allowed; }
    .ck-btn__icon { font-size: 0.95rem; }
    .ck-btn--next { margin-left: auto; }

    /* ── Pay btn wrap ── */
    .ck-pay-btn-wrap { margin: 0.85rem 0; }

    /* ── Stepper ── */
    .ck-stepper {
      display: flex; align-items: center; margin-bottom: 1.5rem;
      padding: 0.9rem 1.2rem;
      background: linear-gradient(135deg, rgba(0,115,153,0.05) 0%, rgba(79,172,254,0.06) 100%);
      border: 1.5px solid var(--ck-border);
      border-radius: var(--ck-radius);
    }
    .ck-stepper__step { display: flex; align-items: center; gap: 0.65rem; cursor: pointer; padding: 0.4rem 0.65rem; border-radius: var(--ck-radius-sm); transition: all 0.2s var(--transition-smooth); flex: 1; }
    .ck-stepper__step:hover { background: rgba(0,115,153,0.07); }
    .ck-stepper__step--active .ck-stepper__num {
      background: linear-gradient(135deg, var(--elakay-primary) 0%, var(--elakay-accent) 100%);
      color: #fff; border-color: transparent;
      box-shadow: 0 3px 10px rgba(0,115,153,0.35);
    }
    .ck-stepper__step--active .ck-stepper__label { color: var(--elakay-primary); font-weight: 700; }
    .ck-stepper__num {
      width: 28px; height: 28px; border-radius: 50%;
      background: #fff; border: 1.5px solid var(--ck-border);
      font-size: 0.72rem; font-weight: 700;
      display: flex; align-items: center; justify-content: center;
      color: var(--ck-text-muted); flex-shrink: 0;
      transition: all 0.25s var(--transition-bounce);
    }
    .ck-stepper__label { font-size: 0.85rem; color: var(--ck-text-muted); transition: all 0.2s; font-weight: 500; }
    .ck-stepper__line { flex: 1; height: 2px; background: linear-gradient(90deg, var(--ck-border) 0%, var(--elakay-accent) 100%); margin: 0 0.75rem; max-width: 60px; border-radius: 2px; }

    /* ── Radio / Checkbox ── */
    .ck-radio-group { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 1rem; }
    .ck-radio-option, .ck-checkbox-option {
      display: flex; align-items: center; gap: 0.7rem; cursor: pointer;
      font-size: 0.875rem; color: var(--ck-text); padding: 0.65rem 0.9rem;
      border-radius: var(--ck-radius-sm); border: 1.5px solid var(--ck-border);
      background: var(--ck-bg-card2); transition: all 0.18s var(--transition-smooth);
      font-weight: 500;
    }
    .ck-radio-option:hover, .ck-checkbox-option:hover {
      border-color: var(--elakay-primary-light);
      background: rgba(0,115,153,0.04);
      transform: translateX(2px);
    }
    .ck-radio-option input, .ck-checkbox-option input { display: none; }
    .ck-radio-custom, .ck-checkbox-custom {
      width: 17px; height: 17px; border-radius: 50%;
      border: 2px solid var(--ck-border); flex-shrink: 0;
      position: relative; transition: all 0.18s var(--transition-bounce);
      background: #fff;
    }
    .ck-checkbox-custom { border-radius: 5px; }
    .ck-radio-option input:checked ~ .ck-radio-custom,
    .ck-checkbox-option input:checked ~ .ck-checkbox-custom {
      border-color: var(--elakay-primary);
      background: linear-gradient(135deg, var(--elakay-primary) 0%, var(--elakay-accent) 100%);
      box-shadow: 0 2px 8px rgba(0,115,153,0.3);
    }
    .ck-radio-option input:checked ~ .ck-radio-custom::after {
      content: ''; position: absolute; width: 6px; height: 6px;
      border-radius: 50%; background: #fff;
      top: 50%; left: 50%; transform: translate(-50%,-50%);
    }
    .ck-checkbox-option input:checked ~ .ck-checkbox-custom::after {
      content: '✓'; position: absolute; font-size: 10px; font-weight: 800;
      color: #fff; top: 50%; left: 50%; transform: translate(-50%,-50%);
    }
    .ck-optional-checks { display: flex; flex-direction: column; gap: 0.5rem; margin: 1rem 0; }

    /* ── Graphic page ── */
    .ck-graphic-page { padding: 0.25rem 0; }

    /* ── Nav actions ── */
    .ck-nav-actions {
      display: flex; justify-content: flex-end; margin-top: 1rem;
      padding-top: 0.85rem; border-top: 1.5px solid var(--ck-border);
    }

    /* ── Alerts ── */
    .ck-alert { padding: 0.65rem 0.9rem; border-radius: var(--ck-radius-sm); font-size: 0.85rem; margin-bottom: 0.75rem; }
    .ck-alert--danger { background: rgba(239,68,68,0.08); border: 1px solid rgba(239,68,68,0.25); color: var(--elakay-danger); }

    /* ── Loader button ── */
    .ck-loading-btn {
      display: flex; align-items: center; justify-content: center; gap: 0.5rem;
      width: 100%; padding: 0.75rem; background: var(--ck-bg-card2);
      border-radius: var(--ck-radius-sm); color: var(--ck-text-muted);
      font-size: 0.875rem; border: 1.5px solid var(--ck-border);
    }
    .ck-loading-btn span { display: inline-block; animation: ck-spin 0.9s linear infinite; color: var(--elakay-primary); }
    @keyframes ck-spin { to { transform: rotate(360deg); } }

    /* ── Modal success ── */
    .ck-success-modal .modal-content {
      background: linear-gradient(135deg, #edfff5 0%, #d6f5e6 100%);
      border: 1.5px solid rgba(52,199,89,0.3);
      border-radius: 14px;
      box-shadow: 0 16px 48px rgba(0,115,153,0.15);
    }
/* 🆕 Modal Bootstrap élargi pour accueillir le GraffitiConfigurator */
.gcv6-checkout-modal {
  max-width: 1320px !important;
  width: 95vw;
}

.gcv6-checkout-modal .modal-content {
  max-height: 95vh;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid #daeaf5;
}

.gcv6-checkout-modal .modal-body {
  padding: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #daeaf5 transparent;
}

.gcv6-checkout-modal .modal-body::-webkit-scrollbar {
  width: 6px;
}

.gcv6-checkout-modal .modal-body::-webkit-scrollbar-thumb {
  background: #daeaf5;
  border-radius: 3px;
}

/* Quand le configurator est affiché, le modal body n'a pas de padding */
.gcv6-checkout-modal .modal-body:has(.gcv6-embedded) {
  padding: 0;
  background: #ffffff;
}

/* Le modal-body padding revient pour l'étape 2 (checkout standard) */
.gcv6-checkout-modal .modal-body:not(:has(.gcv6-embedded)) {
  padding: 1.5rem;
  background: #f2f6fd;
}

@media (max-width: 1200px) {
  .gcv6-checkout-modal {
    max-width: 98vw !important;
  }
}

@media (max-width: 768px) {
  .gcv6-checkout-modal {
    max-width: 100vw !important;
    width: 100vw;
    margin: 0;
  }
  
  .gcv6-checkout-modal .modal-content {
    max-height: 100vh;
    border-radius: 0;
    height: 100vh;
  }
}
    /* ── Modal body dark override ── */
    .ck-modal-body { background: var(--bg-gradient-end); padding: 1.5rem; }
  `;

  /* ══════════════ JSX FINAL ══════════════ */
  return (
    <div className="ck-root">
      <style>{styles}</style>

      {!modalOnly && <>
      {/* Résumé toujours visible -- from "Items" to "Secure checkout" */}
      <OrderSummaryTable showLineList={false} />

      {aboveActions}

      {/* Bouton d'entrée */}
      <div style={{ marginTop: '1rem' }}>
        {laodButton
          ? BSbutton()
          : <div className="ck-loading-btn"><span>⟳</span>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).checkoutProd.t004}</div>
        }
           {buttonAddCart && buttonAddCart("ck-btn ck-btn--primary ck-btn--block mt-3")}

        <div className="pv-secure checkout" style={{ marginTop: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.82rem', color: '#8a8890' }}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="11" width="18" height="11" rx="2"/>
                                        <path d="M7 11V7a5 5 0 0110 0v4"/>
                                    </svg>
                                    {infoSource.laguangeElakay('label', infoSource.languageAPI).secureCheckout || 'Secure checkout'}
                                </div>
      </div>
      </>}

      {/* Modal checkout */}
<Modal
  size="xl"
  show={PaymentCh}
  onHide={() => {
    setPayment(false);
    setGraphicSubmitted(false);
    setGraphicOrderInfo(null);
    setPrixCreatorDesign(0);
    onClose && onClose();
  }}
  dialogClassName="modal-90w checkout-graphic-dialog"
  contentClassName="checkout-graphic-content"
  centered
>
  <Modal.Header
    closeButton
    style={{
      background: "#ffffff",
      borderBottom: "1.5px solid #daeaf5",
      color: "#0d2d3d"
    }}
  >
    <Modal.Title
      style={{
        fontFamily: "Plus Jakarta Sans, sans-serif",
        fontSize: "1.1rem",
        fontWeight: 700,
        color: "#007399"
      }}
    >
      {products?.[0]?.graphic && !graphicSubmitted
        ? elakayAutoText("h_e5a8f480aae840", "🎨 Customize Your Design — Step 1 of 2")
        : products?.[0]?.graphic && graphicSubmitted
        ? elakayAutoText("h_18a79de34ec23d", "💳 Shipping & Payment — Step 2 of 2")
        : infoSource.laguangeElakay("title", infoSource.languageAPI).checkout}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body
    className="checkout-graphic-body"
    style={{
      background: "#f2f6fd",
      padding: products?.[0]?.graphic && !graphicSubmitted ? 0 : "1.5rem",
      overflow: "hidden"
    }}
  >
    <div
      className="ck-root"
      style={{
        padding: 0,
        borderRadius: 0,
        height:
          products?.[0]?.graphic && !graphicSubmitted
            ? "100%"
            : "auto"
      }}
    >
      {allPageGraphic_Payment()}
    </div>
  </Modal.Body>
</Modal>



      {/* Redirect */}
      {redicectToFilters(data.redirectToFilter)}

      {/* Stripe error */}
      <StripeError
        laguangeElakay={laguangeElakay}
        infoSource={infoSource}
        show={show}
        setShow={setShow}
        listePM_createStripeCusTomer={listePM_createStripeCusTomer}
      />

      {/* Modal confirmation paiement */}
      {/* <Modal
        show={showModalPaietSMS}
        onHide={() => setShowModalPaietSMS(false)}
        centered
        contentClassName="ck-success-modal"
      >
        <Modal.Body style={{ padding: '1.25rem' }}>
          <ErrorAlert success={success} setSuccess={setSuccess} duration={9000} />
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

// Même patron que src/includes/pageInside/Stripe/stripeIndex.jsx : une seule
// promesse Stripe.js par montage, réutilisée par tous les rendus de Checkout.
const stripePromise = REACT_PK ? loadStripe(REACT_PK) : null;

const Checkout = (props) => (
  <Elements stripe={stripePromise}>
    <CheckoutForm {...props} />
  </Elements>
);

export default Checkout;
